var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyConsumptionAndPricesDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 456.38 439.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-197);}.cls-2{clip-path:url(#clippath-76);}.cls-3{clip-path:url(#clippath-281);}.cls-4{clip-path:url(#clippath-189);}.cls-5{clip-path:url(#clippath-51);}.cls-6{clip-path:url(#clippath-329);}.cls-7{clip-path:url(#clippath-143);}.cls-8{clip-path:url(#clippath-34);}.cls-9{clip-path:url(#clippath-107);}.cls-10{clip-path:url(#clippath-204);}.cls-11{clip-path:url(#clippath-133);}.cls-12{clip-path:url(#clippath-211);}.cls-13{clip-path:url(#clippath-222);}.cls-14{clip-path:url(#clippath-38);}.cls-15{clip-path:url(#clippath-21);}.cls-16{clip-path:url(#clippath-165);}.cls-17{clip-path:url(#clippath-213);}.cls-18{clip-path:url(#clippath-6);}.cls-19{clip-path:url(#clippath-7);}.cls-20{clip-path:url(#clippath-17);}.cls-21{clip-path:url(#clippath-224);}.cls-22{clip-path:url(#clippath-80);}.cls-23{clip-path:url(#clippath-31);}.cls-24{clip-path:url(#clippath-79);}.cls-25{clip-path:url(#clippath-138);}.cls-26{clip-path:url(#clippath-75);}.cls-27{clip-path:url(#clippath-212);}.cls-28{clip-path:url(#clippath-332);}.cls-29{clip-path:url(#clippath-172);}.cls-30{clip-path:url(#clippath-15);}.cls-31{clip-path:url(#clippath-33);}.cls-32{clip-path:url(#clippath-61);}.cls-33{clip-path:url(#clippath-234);}.cls-34{clip-path:url(#clippath-116);}.cls-35{clip-path:url(#clippath-241);}.cls-36{clip-path:url(#clippath-201);}.cls-37{clip-path:url(#clippath-337);}.cls-38{clip-path:url(#clippath-100);}.cls-39{clip-path:url(#clippath-18);}.cls-40{clip-path:url(#clippath-47);}.cls-41{clip-path:url(#clippath-240);}.cls-42{clip-path:url(#clippath-4);}.cls-43{clip-path:url(#clippath-260);}.cls-44{clip-path:url(#clippath-71);}.cls-45{clip-path:url(#clippath-232);}.cls-46{clip-path:url(#clippath-126);}.cls-47{fill:#333;}.cls-48{clip-path:url(#clippath-167);}.cls-49{clip-path:url(#clippath-343);}.cls-50{clip-path:url(#clippath-120);}.cls-51{clip-path:url(#clippath-228);}.cls-52{clip-path:url(#clippath-344);}.cls-53{clip-path:url(#clippath-22);}.cls-54{clip-path:url(#clippath-257);}.cls-55{clip-path:url(#clippath-264);}.cls-56{clip-path:url(#clippath-333);}.cls-57{clip-path:url(#clippath-103);}.cls-58{clip-path:url(#clippath-306);}.cls-59{clip-path:url(#clippath-23);}.cls-60{clip-path:url(#clippath-158);}.cls-61{clip-path:url(#clippath-262);}.cls-62{clip-path:url(#clippath-249);}.cls-63{clip-path:url(#clippath-216);}.cls-64{clip-path:url(#clippath-191);}.cls-65{clip-path:url(#clippath-196);}.cls-66{clip-path:url(#clippath-253);}.cls-67{clip-path:url(#clippath-342);}.cls-68{clip-path:url(#clippath-140);}.cls-69{clip-path:url(#clippath-195);}.cls-70{clip-path:url(#clippath-327);}.cls-71{clip-path:url(#clippath-294);}.cls-72{clip-path:url(#clippath-199);}.cls-73{clip-path:url(#clippath-288);}.cls-74{clip-path:url(#clippath-82);}.cls-75{clip-path:url(#clippath-296);}.cls-76{clip-path:url(#clippath-54);}.cls-77{clip-path:url(#clippath-66);}.cls-78{clip-path:url(#clippath-238);}.cls-79{clip-path:url(#clippath-114);}.cls-80{clip-path:url(#clippath-149);}.cls-81{clip-path:url(#clippath-298);}.cls-82{clip-path:url(#clippath-128);}.cls-83{clip-path:url(#clippath-9);}.cls-84{clip-path:url(#clippath-142);}.cls-85{clip-path:url(#clippath-121);}.cls-86{clip-path:url(#clippath-102);}.cls-87{clip-path:url(#clippath-70);}.cls-88{clip-path:url(#clippath-276);}.cls-89{clip-path:url(#clippath-10);}.cls-90{clip-path:url(#clippath-320);}.cls-91{clip-path:url(#clippath-42);}.cls-92{clip-path:url(#clippath-164);}.cls-93{clip-path:url(#clippath-331);}.cls-94{clip-path:url(#clippath-132);}.cls-95{clip-path:url(#clippath-59);}.cls-96{clip-path:url(#clippath-148);}.cls-97{clip-path:url(#clippath-335);}.cls-98{clip-path:url(#clippath-328);}.cls-99{clip-path:url(#clippath-160);}.cls-100{clip-path:url(#clippath-43);}.cls-101{clip-path:url(#clippath-64);}.cls-102{clip-path:url(#clippath-287);}.cls-103{clip-path:url(#clippath-101);}.cls-104{clip-path:url(#clippath-25);}.cls-105{clip-path:url(#clippath-317);}.cls-106{clip-path:url(#clippath-267);}.cls-107{clip-path:url(#clippath-155);}.cls-108{clip-path:url(#clippath-27);}.cls-109{clip-path:url(#clippath-290);}.cls-110{clip-path:url(#clippath-139);}.cls-111{clip-path:url(#clippath-109);}.cls-112{clip-path:url(#clippath-273);}.cls-113{clip-path:url(#clippath-251);}.cls-114{clip-path:url(#clippath-151);}.cls-115{stroke:#333;}.cls-115,.cls-116,.cls-117,.cls-118{fill:none;}.cls-115,.cls-117{stroke-width:.7px;}.cls-119{clip-path:url(#clippath-244);}.cls-120{clip-path:url(#clippath-130);}.cls-121{clip-path:url(#clippath-206);}.cls-122{clip-path:url(#clippath-227);}.cls-123{clip-path:url(#clippath-179);}.cls-124{clip-path:url(#clippath-315);}.cls-125{clip-path:url(#clippath-292);}.cls-126{clip-path:url(#clippath-60);}.cls-127{clip-path:url(#clippath-252);}.cls-128{clip-path:url(#clippath-280);}.cls-129{clip-path:url(#clippath-176);}.cls-130{clip-path:url(#clippath-113);}.cls-131{clip-path:url(#clippath-171);}.cls-132{clip-path:url(#clippath-93);}.cls-133{clip-path:url(#clippath-205);}.cls-134{clip-path:url(#clippath-309);}.cls-135{clip-path:url(#clippath-236);}.cls-136{clip-path:url(#clippath-11);}.cls-137{clip-path:url(#clippath-226);}.cls-138{clip-path:url(#clippath-57);}.cls-139{clip-path:url(#clippath-310);}.cls-140{clip-path:url(#clippath-88);}.cls-141{clip-path:url(#clippath-274);}.cls-142{clip-path:url(#clippath-170);}.cls-143{clip-path:url(#clippath-293);}.cls-144{clip-path:url(#clippath-85);}.cls-145{clip-path:url(#clippath-248);}.cls-146{clip-path:url(#clippath-291);}.cls-147{clip-path:url(#clippath-270);}.cls-148{clip-path:url(#clippath-159);}.cls-149{clip-path:url(#clippath-111);}.cls-150{clip-path:url(#clippath-168);}.cls-151{clip-path:url(#clippath-277);}.cls-152{clip-path:url(#clippath-105);}.cls-153{clip-path:url(#clippath-208);}.cls-154{clip-path:url(#clippath-36);}.cls-155{clip-path:url(#clippath-92);}.cls-156{clip-path:url(#clippath-174);}.cls-157{clip-path:url(#clippath-182);}.cls-158{clip-path:url(#clippath-147);}.cls-159{clip-path:url(#clippath-35);}.cls-160{clip-path:url(#clippath-98);}.cls-161{clip-path:url(#clippath-48);}.cls-162{clip-path:url(#clippath-104);}.cls-163{clip-path:url(#clippath-214);}.cls-164{clip-path:url(#clippath-209);}.cls-165{clip-path:url(#clippath-28);}.cls-166{clip-path:url(#clippath-266);}.cls-167{clip-path:url(#clippath-299);}.cls-168{clip-path:url(#clippath-193);}.cls-169{clip-path:url(#clippath-118);}.cls-117{stroke:#e6e6e6;}.cls-170{clip-path:url(#clippath-282);}.cls-171{clip-path:url(#clippath-338);}.cls-172{clip-path:url(#clippath-297);}.cls-173{clip-path:url(#clippath-56);}.cls-174{clip-path:url(#clippath-108);}.cls-175{clip-path:url(#clippath-221);}.cls-176{clip-path:url(#clippath-307);}.cls-177{clip-path:url(#clippath-312);}.cls-178{clip-path:url(#clippath-141);}.cls-179{clip-path:url(#clippath-283);}.cls-180{clip-path:url(#clippath-220);}.cls-181{clip-path:url(#clippath-90);}.cls-182{clip-path:url(#clippath-45);}.cls-183{fill:#00b490;}.cls-184{clip-path:url(#clippath-110);}.cls-185{clip-path:url(#clippath-99);}.cls-186{clip-path:url(#clippath-89);}.cls-187{clip-path:url(#clippath-46);}.cls-188{clip-path:url(#clippath-40);}.cls-189{clip-path:url(#clippath-203);}.cls-190{clip-path:url(#clippath-304);}.cls-191{clip-path:url(#clippath-180);}.cls-192{clip-path:url(#clippath-223);}.cls-193{clip-path:url(#clippath-96);}.cls-194{clip-path:url(#clippath-5);}.cls-195{clip-path:url(#clippath-20);}.cls-118{stroke:#cccccb;stroke-width:.5px;}.cls-196{clip-path:url(#clippath-202);}.cls-197{clip-path:url(#clippath-217);}.cls-198{clip-path:url(#clippath-95);}.cls-199{clip-path:url(#clippath-8);}.cls-200{clip-path:url(#clippath-258);}.cls-201{clip-path:url(#clippath-321);}.cls-202{clip-path:url(#clippath-52);}.cls-203{clip-path:url(#clippath-286);}.cls-204{clip-path:url(#clippath-41);}.cls-205{clip-path:url(#clippath-67);}.cls-206{clip-path:url(#clippath-305);}.cls-207{clip-path:url(#clippath-154);}.cls-208{clip-path:url(#clippath-162);}.cls-209{clip-path:url(#clippath-271);}.cls-210{clip-path:url(#clippath-74);}.cls-211{clip-path:url(#clippath-326);}.cls-212{clip-path:url(#clippath-190);}.cls-213{clip-path:url(#clippath-3);}.cls-214{clip-path:url(#clippath-250);}.cls-215{clip-path:url(#clippath-146);}.cls-216{clip-path:url(#clippath-26);}.cls-217{clip-path:url(#clippath-91);}.cls-218{clip-path:url(#clippath-340);}.cls-219{clip-path:url(#clippath-137);}.cls-220{clip-path:url(#clippath-12);}.cls-221{clip-path:url(#clippath-225);}.cls-222{clip-path:url(#clippath-242);}.cls-223{clip-path:url(#clippath-135);}.cls-224{clip-path:url(#clippath-50);}.cls-225{clip-path:url(#clippath-153);}.cls-226{clip-path:url(#clippath-14);}.cls-227{clip-path:url(#clippath-183);}.cls-228{fill:#004c8b;}.cls-229{clip-path:url(#clippath-186);}.cls-230{clip-path:url(#clippath-339);}.cls-231{clip-path:url(#clippath-265);}.cls-232{clip-path:url(#clippath-322);}.cls-233{clip-path:url(#clippath-97);}.cls-234{clip-path:url(#clippath-30);}.cls-235{clip-path:url(#clippath-247);}.cls-236{clip-path:url(#clippath-112);}.cls-237{clip-path:url(#clippath-77);}.cls-238{clip-path:url(#clippath-19);}.cls-239{clip-path:url(#clippath-272);}.cls-240{clip-path:url(#clippath-259);}.cls-241{clip-path:url(#clippath-127);}.cls-242{clip-path:url(#clippath-117);}.cls-243{clip-path:url(#clippath-207);}.cls-244{clip-path:url(#clippath-218);}.cls-245{clip-path:url(#clippath-239);}.cls-246{clip-path:url(#clippath-78);}.cls-247{clip-path:url(#clippath-194);}.cls-248{fill:#2d1e45;}.cls-249{clip-path:url(#clippath-72);}.cls-250{clip-path:url(#clippath-84);}.cls-251{clip-path:url(#clippath-330);}.cls-252{clip-path:url(#clippath-32);}.cls-253{clip-path:url(#clippath-219);}.cls-254{clip-path:url(#clippath-215);}.cls-255{clip-path:url(#clippath-229);}.cls-256{clip-path:url(#clippath-175);}.cls-257{clip-path:url(#clippath-256);}.cls-258{clip-path:url(#clippath-275);}.cls-259{clip-path:url(#clippath-145);}.cls-260{clip-path:url(#clippath-166);}.cls-261{clip-path:url(#clippath-210);}.cls-262{clip-path:url(#clippath-319);}.cls-263{clip-path:url(#clippath-300);}.cls-264{clip-path:url(#clippath-55);}.cls-265{clip-path:url(#clippath-123);}.cls-266{clip-path:url(#clippath-318);}.cls-267{clip-path:url(#clippath-269);}.cls-268{clip-path:url(#clippath-129);}.cls-269{clip-path:url(#clippath-324);}.cls-270{clip-path:url(#clippath-245);}.cls-271{clip-path:url(#clippath-254);}.cls-272{clip-path:url(#clippath-188);}.cls-273{clip-path:url(#clippath-150);}.cls-274{clip-path:url(#clippath-268);}.cls-275{clip-path:url(#clippath-341);}.cls-276{clip-path:url(#clippath-73);}.cls-277{clip-path:url(#clippath-263);}.cls-278{clip-path:url(#clippath-181);}.cls-279{clip-path:url(#clippath-53);}.cls-280{clip-path:url(#clippath-323);}.cls-281{fill:#010101;}.cls-282{clip-path:url(#clippath-39);}.cls-283{clip-path:url(#clippath-122);}.cls-284{clip-path:url(#clippath-81);}.cls-285{clip-path:url(#clippath-178);}.cls-286{clip-path:url(#clippath-295);}.cls-287{clip-path:url(#clippath-106);}.cls-288{clip-path:url(#clippath-125);}.cls-289{clip-path:url(#clippath-334);}.cls-290{clip-path:url(#clippath-16);}.cls-291{clip-path:url(#clippath-119);}.cls-292{clip-path:url(#clippath-2);}.cls-293{clip-path:url(#clippath-231);}.cls-294{clip-path:url(#clippath-285);}.cls-295{clip-path:url(#clippath-29);}.cls-296{clip-path:url(#clippath-131);}.cls-297{clip-path:url(#clippath-156);}.cls-298{clip-path:url(#clippath-230);}.cls-299{clip-path:url(#clippath-314);}.cls-300{clip-path:url(#clippath-301);}.cls-301{clip-path:url(#clippath-49);}.cls-302{clip-path:url(#clippath-37);}.cls-303{clip-path:url(#clippath-58);}.cls-304{clip-path:url(#clippath-124);}.cls-305{clip-path:url(#clippath-13);}.cls-306{clip-path:url(#clippath-136);}.cls-307{clip-path:url(#clippath-243);}.cls-308{clip-path:url(#clippath-325);}.cls-309{clip-path:url(#clippath-289);}.cls-310{clip-path:url(#clippath-86);}.cls-311{clip-path:url(#clippath-198);}.cls-312{clip-path:url(#clippath-144);}.cls-313{clip-path:url(#clippath-63);}.cls-314{clip-path:url(#clippath-200);}.cls-315{clip-path:url(#clippath-24);}.cls-316{clip-path:url(#clippath-94);}.cls-317{clip-path:url(#clippath-235);}.cls-318{clip-path:url(#clippath);}.cls-319{clip-path:url(#clippath-311);}.cls-320{clip-path:url(#clippath-303);}.cls-321{clip-path:url(#clippath-255);}.cls-322{clip-path:url(#clippath-173);}.cls-323{clip-path:url(#clippath-261);}.cls-324{clip-path:url(#clippath-237);}.cls-325{clip-path:url(#clippath-302);}.cls-326{clip-path:url(#clippath-87);}.cls-327{clip-path:url(#clippath-68);}.cls-328{clip-path:url(#clippath-83);}.cls-329{clip-path:url(#clippath-336);}.cls-330{clip-path:url(#clippath-308);}.cls-331{clip-path:url(#clippath-185);}.cls-332{clip-path:url(#clippath-65);}.cls-333{clip-path:url(#clippath-134);}.cls-334{clip-path:url(#clippath-157);}.cls-335{clip-path:url(#clippath-246);}.cls-336{clip-path:url(#clippath-313);}.cls-337{clip-path:url(#clippath-316);}.cls-338{clip-path:url(#clippath-169);}.cls-339{clip-path:url(#clippath-44);}.cls-340{clip-path:url(#clippath-284);}.cls-341{clip-path:url(#clippath-177);}.cls-342{clip-path:url(#clippath-184);}.cls-343{clip-path:url(#clippath-115);}.cls-344{clip-path:url(#clippath-278);}.cls-345{clip-path:url(#clippath-163);}.cls-346{clip-path:url(#clippath-62);}.cls-347{clip-path:url(#clippath-69);}.cls-348{clip-path:url(#clippath-161);}.cls-349{clip-path:url(#clippath-152);}.cls-350{clip-path:url(#clippath-279);}.cls-351{clip-path:url(#clippath-233);}.cls-352{clip-path:url(#clippath-187);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-172"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-173"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-174"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-175"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-176"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-177"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-178"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-179"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-180"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-181"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-182"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-183"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-184"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-185"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-186"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-187"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-188"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-189"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-190"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 0,
    y: 24.91,
    width: 269.29,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-191"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-193"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-194"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-195"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-196"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-197"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-198"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-199"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-200"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-201"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-202"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-203"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-205"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-206"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-207"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-208"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-209"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-211"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-212"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-213"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-214"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-215"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-216"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-217"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-218"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-219"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-220"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-221"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-222"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-223"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-224"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-225"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-226"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-227"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-228"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-229"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-230"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-231"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-232"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-233"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-234"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-235"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-236"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-237"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-238"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-239"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-240"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-241"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-242"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-243"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-244"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-245"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-246"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-247"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-248"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-249"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-250"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-251"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-252"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-253"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-254"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-255"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-256"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-257"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-258"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-259"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-260"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-261"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-262"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-263"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-264"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-265"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-266"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-267"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-268"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-269"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-270"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-271"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-272"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-273"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-274"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-275"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-276"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-277"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-278"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-279"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-280"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-281"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-282"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-283"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-284"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-285"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-286"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-287"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-289"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-290"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-291"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-292"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-293"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-294"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-295"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-296"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-297"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-298"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-299"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-300"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-301"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-302"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-303"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-304"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-305"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-306"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-307"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-308"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-309"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-310"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-311"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-312"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-313"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-314"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-315"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-316"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-317"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-318"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-319"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-320"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-321"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-322"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-323"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-324"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-325"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-326"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-327"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-328"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-329"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-330"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-331"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-332"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-333"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-334"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-335"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-336"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-337"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-338"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-339"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-340"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-341"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-342"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-343"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-344"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 283.41,
    y: 24.91,
    width: 172.91,
    height: 414.46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element_1_copy3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 30.39,
    x2: 269.29,
    y2: 30.39
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 44.7,
    x2: 269.29,
    y2: 44.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 59.01,
    x2: 269.29,
    y2: 59.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 73.32,
    x2: 269.29,
    y2: 73.32
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 87.63,
    x2: 269.29,
    y2: 87.63
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 101.94,
    x2: 269.29,
    y2: 101.94
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 116.25,
    x2: 269.29,
    y2: 116.25
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 130.56,
    x2: 269.29,
    y2: 130.56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 144.87,
    x2: 269.29,
    y2: 144.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 159.19,
    x2: 269.29,
    y2: 159.19
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 173.5,
    x2: 269.29,
    y2: 173.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-305"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 187.81,
    x2: 269.29,
    y2: 187.81
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 202.12,
    x2: 269.29,
    y2: 202.12
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 216.43,
    x2: 269.29,
    y2: 216.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 230.74,
    x2: 269.29,
    y2: 230.74
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 245.05,
    x2: 269.29,
    y2: 245.05
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 259.36,
    x2: 269.29,
    y2: 259.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 273.67,
    x2: 269.29,
    y2: 273.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 287.98,
    x2: 269.29,
    y2: 287.98
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 302.3,
    x2: 269.29,
    y2: 302.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 316.61,
    x2: 269.29,
    y2: 316.61
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 330.92,
    x2: 269.29,
    y2: 330.92
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-315"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 345.23,
    x2: 269.29,
    y2: 345.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 359.54,
    x2: 269.29,
    y2: 359.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 373.85,
    x2: 269.29,
    y2: 373.85
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 388.16,
    x2: 269.29,
    y2: 388.16
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 402.47,
    x2: 269.29,
    y2: 402.47
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 416.78,
    x2: 269.29,
    y2: 416.78
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 142.47,
    y1: 26.81,
    x2: 142.47,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 100.2,
    y1: 26.81,
    x2: 100.2,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 184.74,
    y1: 26.81,
    x2: 184.74,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 227.02,
    y1: 26.81,
    x2: 227.02,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 269.29,
    y1: 26.81,
    x2: 269.29,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 29.67,
    width: 108.22,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 43.98,
    width: 87.93,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-302"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 58.29,
    width: 78.63,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 72.6,
    width: 72.71,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-282"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 86.91,
    width: 71.87,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 101.23,
    width: 70.17,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 115.54,
    width: 69.33,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 129.85,
    width: 52.42,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 144.16,
    width: 50.73,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-339"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 158.47,
    width: 49.04,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 172.78,
    width: 47.35,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 187.09,
    width: 40.58,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 201.4,
    width: 39.74,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "142.47 215.71 178.83 215.71 178.83 217.14 142.47 217.14 142.47 215.71 142.47 215.71"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-301"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "142.47 230.02 177.98 230.02 177.98 231.46 142.47 231.46 142.47 230.02 142.47 230.02"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 244.34,
    width: 28.75,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 258.65,
    width: 21.14,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 272.96,
    width: 15.22,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-279"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 287.27,
    width: 10.99,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 301.58,
    width: 10.99,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 315.89,
    width: 10.99,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 330.2,
    width: 10.15,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 142.47,
    y: 344.51,
    width: 2.54,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-303"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 136.55,
    y: 358.82,
    width: 5.92,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 135.71,
    y: 373.13,
    width: 6.76,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 133.17,
    y: 387.45,
    width: 9.3,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 125.56,
    y: 401.76,
    width: 16.91,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-346"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "103.58 416.07 142.47 416.07 142.47 417.5 103.58 417.5 103.58 416.07 103.58 416.07"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 250.69,
    cy: 30.39,
    r: 2.83,
    transform: "translate(173.45 270.81) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 230.4,
    cy: 44.7,
    r: 2.83,
    transform: "translate(142.94 262.49) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-332"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 221.1,
    cy: 59.01,
    r: 2.83,
    transform: "translate(121.34 264.96) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 215.18,
    cy: 73.32,
    r: 2.83,
    transform: "translate(102.49 270.75) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 214.34,
    cy: 87.63,
    r: 2.83,
    transform: "translate(87.75 281.53) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-327"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 212.64,
    cy: 101.94,
    r: 2.83,
    transform: "translate(72.33 291.47) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-347"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 211.8,
    cy: 116.25,
    r: 2.83,
    transform: "translate(57.59 302.25) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 194.89,
    cy: 130.56,
    r: 2.83,
    transform: "translate(29.83 297.25) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 193.2,
    cy: 144.87,
    r: 2.83,
    transform: "translate(14.4 307.19) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 191.51,
    cy: 159.19,
    r: 2.83,
    transform: "translate(-1.02 317.13) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 189.82,
    cy: 173.5,
    r: 2.83,
    transform: "translate(-16.45 327.08) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 183.05,
    cy: 187.81,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 182.21,
    cy: 202.12,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-248",
    cx: 178.83,
    cy: 216.43,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 177.98,
    cy: 230.74,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 171.22,
    cy: 245.05,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 163.61,
    cy: 259.36,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 157.69,
    cy: 273.67,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 153.46,
    cy: 287.98,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 153.46,
    cy: 302.3,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-328"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 153.46,
    cy: 316.61,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 152.62,
    cy: 330.92,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 145.01,
    cy: 345.23,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-310"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 136.55,
    cy: 359.54,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-326"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 135.71,
    cy: 373.85,
    r: 2.83,
    transform: "translate(-20.47 8.08) rotate(-3.17)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 133.17,
    cy: 388.16,
    r: 2.83,
    transform: "translate(-260.63 503.61) rotate(-87.4)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 125.56,
    cy: 402.47,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 103.58,
    cy: 416.78,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 100.2,
    y1: 420.36,
    x2: 100.2,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M74.3,434.71h4.3v.49h-4.3v-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M79.86,436.21s.44.7,1.35.7c.82,0,1.49-.59,1.49-1.4s-.66-1.4-1.51-1.4c-.64,0-1.09.32-1.09.32l-.37-.13.32-2.9h2.89v.53h-2.38l-.17,1.53c-.03.21-.06.34-.06.34h.02s.37-.23.91-.23c1.2,0,2.06.87,2.06,1.95s-.91,1.96-2.07,1.96-1.75-.85-1.75-.85l.37-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M84.56,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M86.44,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM89.95,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M91.63,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM96.24,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM93.52,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM95.7,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM95.7,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-316"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 142.47,
    y1: 420.36,
    x2: 142.47,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M121.33,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM124.84,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M126.83,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M128.71,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM132.22,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M133.91,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM138.51,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM135.79,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM137.97,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM137.97,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 184.74,
    y1: 420.36,
    x2: 184.74,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M164.41,436.21s.44.7,1.35.7c.82,0,1.49-.59,1.49-1.4s-.66-1.4-1.51-1.4c-.64,0-1.09.32-1.09.32l-.37-.13.32-2.9h2.89v.53h-2.38l-.17,1.53c-.03.21-.06.34-.06.34h.02s.37-.23.91-.23c1.2,0,2.06.87,2.06,1.95s-.91,1.96-2.07,1.96-1.75-.85-1.75-.85l.37-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M169.11,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M170.99,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM174.5,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M176.18,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM180.79,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM178.07,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM180.24,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM180.24,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 227.02,
    y1: 420.36,
    x2: 227.02,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M201.79,436.84h1.34v-4.38c0-.17,0-.33,0-.33h-.02s-.06.13-.3.36l-.64.64-.37-.38,1.35-1.34h.54v5.45h1.32v.53h-3.24v-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M205.87,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM209.38,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M211.38,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M213.26,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM216.77,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M218.45,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM223.06,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM220.34,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM222.52,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM222.52,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 269.29,
    y1: 420.36,
    x2: 269.29,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M244.64,436.84h1.34v-4.38c0-.17,0-.33,0-.33h-.02s-.06.13-.3.36l-.64.64-.37-.38,1.35-1.34h.54v5.45h1.32v.53h-3.24v-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M248.96,436.21s.44.7,1.35.7c.82,0,1.49-.59,1.49-1.4s-.66-1.4-1.51-1.4c-.64,0-1.09.32-1.09.32l-.37-.13.32-2.9h2.89v.53h-2.38l-.17,1.53c-.03.21-.06.34-.06.34h.02s.37-.23.91-.23c1.2,0,2.06.87,2.06,1.95s-.91,1.96-2.07,1.96-1.75-.85-1.75-.85l.37-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M253.66,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M255.53,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM259.04,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M260.73,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM265.33,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM262.61,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM264.79,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM264.79,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-115",
    x1: 142.47,
    y1: 26.81,
    x2: 142.47,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M12.02,33.39v-5.9h.77l2.13,3.71.64,1.22h.04c-.02-.3-.04-.61-.06-.93-.02-.32-.03-.64-.03-.95v-3.05h.71v5.9h-.77l-2.14-3.72-.64-1.22h-.04c.02.3.05.6.07.91s.03.62.03.93v3.09h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M19.54,33.49c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM18.16,30.85h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M23.61,33.49c-.23,0-.43-.04-.59-.11s-.29-.17-.39-.3c-.1-.13-.17-.28-.21-.46-.04-.18-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04s.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M25.27,33.39v-6.41h.74v1.75l-.03.9c.21-.2.43-.37.66-.51s.5-.21.8-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.94,33.49c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM30.56,30.85h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.63,33.39v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23s-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M38.54,33.49c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.06,33.49c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM41.27,32.9c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M44.59,33.39v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M51,33.49c-.55,0-.99-.2-1.32-.59-.33-.4-.49-.96-.49-1.69,0-.35.05-.67.16-.96.1-.28.24-.53.42-.72.17-.2.38-.35.6-.46.23-.11.47-.16.72-.16s.47.04.66.13c.19.09.38.21.57.37l-.04-.75v-1.68h.75v6.41h-.61l-.06-.51h-.03c-.17.17-.37.31-.6.44-.23.12-.47.18-.72.18ZM51.17,32.87c.2,0,.4-.05.58-.15.18-.1.36-.25.54-.45v-2.29c-.19-.17-.36-.29-.54-.36s-.35-.1-.53-.1-.34.04-.49.12c-.15.08-.29.19-.4.34-.11.15-.2.32-.27.53-.07.2-.1.43-.1.68,0,.53.1.94.31,1.23s.51.44.89.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.65,33.49c-.31,0-.61-.06-.89-.17-.28-.11-.53-.26-.74-.43l.37-.5c.19.16.39.28.59.38.2.1.43.14.7.14.29,0,.5-.07.65-.2s.22-.29.22-.49c0-.11-.03-.21-.09-.3-.06-.08-.14-.16-.23-.22-.09-.06-.2-.12-.32-.17s-.24-.1-.36-.14c-.16-.05-.31-.12-.47-.18-.16-.07-.3-.15-.42-.25-.12-.1-.22-.21-.3-.35-.08-.13-.12-.29-.12-.48,0-.17.03-.34.1-.49.07-.15.17-.29.3-.4.13-.11.29-.2.47-.26s.4-.09.63-.09c.28,0,.53.05.76.14.23.1.43.21.6.35l-.35.47c-.15-.11-.31-.21-.47-.28-.16-.07-.34-.11-.53-.11-.28,0-.48.06-.61.19-.13.13-.19.27-.19.44,0,.1.03.19.08.27.05.08.13.14.22.2s.19.11.31.15c.12.05.24.09.36.14.16.06.31.12.47.19.16.07.3.15.43.25s.23.22.31.36c.08.14.12.32.12.52,0,.18-.03.35-.1.5-.07.16-.17.29-.31.41-.14.12-.3.21-.5.28s-.43.1-.69.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.49,47.81c-.37,0-.71-.07-1.03-.21-.31-.14-.58-.34-.81-.6-.23-.26-.41-.58-.54-.96-.13-.38-.19-.81-.19-1.29s.07-.9.2-1.28.31-.7.55-.96c.23-.26.51-.47.83-.61.32-.14.67-.21,1.04-.21s.68.07.95.22c.27.15.5.32.67.51l-.41.49c-.16-.17-.33-.3-.53-.41-.2-.1-.42-.15-.67-.15-.28,0-.54.06-.77.17s-.42.27-.58.48-.29.46-.37.75-.13.62-.13.99.04.71.13,1c.09.3.21.55.36.76.16.21.35.37.57.49.23.11.48.17.76.17s.54-.06.76-.18c.22-.12.42-.28.61-.49l.41.47c-.23.27-.5.48-.79.63s-.63.23-1.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.4,49.58c-.1,0-.2,0-.28-.02s-.16-.04-.23-.07l.14-.58s.1.03.16.04c.06.01.12.02.17.02.25,0,.46-.09.62-.27.16-.18.28-.4.37-.67l.1-.32-1.75-4.38h.77l.89,2.42c.07.19.14.39.21.61.07.21.15.42.21.63h.04c.07-.2.13-.4.19-.62.06-.22.12-.42.18-.61l.78-2.42h.72l-1.65,4.73c-.08.22-.17.42-.26.6-.1.19-.21.35-.34.48-.13.14-.28.24-.45.32-.17.08-.36.12-.58.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.53,49.54v-6.22h.61l.06.5h.03c.2-.17.42-.31.65-.43.24-.12.48-.18.74-.18.28,0,.53.05.75.16.22.11.4.26.54.45s.25.43.33.7c.07.27.11.58.11.92,0,.37-.05.7-.15.99-.1.29-.24.54-.41.74-.17.2-.38.36-.6.46-.23.1-.47.16-.72.16-.2,0-.41-.04-.61-.13-.2-.09-.4-.21-.61-.37l.02.77v1.48h-.74ZM43.34,47.18c.18,0,.35-.04.5-.12.15-.08.29-.2.4-.34s.2-.33.26-.54.09-.46.09-.73c0-.24-.02-.46-.06-.66-.04-.2-.11-.37-.2-.51-.09-.14-.21-.25-.36-.33-.15-.08-.32-.12-.53-.12-.19,0-.37.05-.56.15s-.39.25-.61.44v2.29c.2.17.39.29.58.36.19.07.35.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.52,47.7v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23s-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.92,47.81c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.27.63.27.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.1h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58s-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.68,47.81c-.31,0-.61-.06-.89-.17-.28-.11-.53-.26-.74-.43l.37-.5c.19.16.39.28.59.38.2.1.43.14.7.14.29,0,.5-.07.65-.2s.22-.29.22-.49c0-.11-.03-.21-.09-.3-.06-.08-.14-.16-.23-.22-.09-.06-.2-.12-.32-.17s-.24-.1-.36-.14c-.16-.05-.31-.12-.47-.18-.16-.07-.3-.15-.42-.25-.12-.1-.22-.21-.3-.35-.08-.13-.12-.29-.12-.48,0-.17.03-.34.1-.49.07-.15.17-.29.3-.4.13-.11.29-.2.47-.26s.4-.09.63-.09c.28,0,.53.05.76.14.23.1.43.21.6.35l-.35.47c-.15-.11-.31-.21-.47-.28-.16-.07-.34-.11-.53-.11-.28,0-.48.06-.61.19-.13.13-.19.27-.19.44,0,.1.03.19.08.27.05.08.13.14.22.2s.19.11.31.15c.12.05.24.09.36.14.16.06.31.12.47.19.16.07.3.15.43.25s.23.22.31.36c.08.14.12.32.12.52,0,.18-.03.35-.1.5-.07.16-.17.29-.31.41-.14.12-.3.21-.5.28s-.43.1-.69.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.33,62.01l2-5.9h.85l2,5.9h-.8l-.56-1.8h-2.15l-.57,1.8h-.77ZM33.13,58.71l-.28.9h1.77l-.28-.9c-.11-.33-.21-.66-.31-.99-.1-.33-.19-.66-.29-1h-.04c-.09.34-.18.68-.28,1-.1.33-.2.66-.31.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M38.21,62.12c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.27.63.27.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.1h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58s-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.98,62.12c-.31,0-.61-.06-.89-.17-.28-.11-.53-.26-.74-.43l.37-.5c.19.16.39.28.59.38.2.1.43.14.7.14.29,0,.5-.07.65-.2s.22-.29.22-.49c0-.11-.03-.21-.09-.3-.06-.08-.14-.16-.23-.22-.09-.06-.2-.12-.32-.17s-.24-.1-.36-.14c-.16-.05-.31-.12-.47-.18-.16-.07-.3-.15-.42-.25-.12-.1-.22-.21-.3-.35-.08-.13-.12-.29-.12-.48,0-.17.03-.34.1-.49.07-.15.17-.29.3-.4.13-.11.29-.2.47-.26s.4-.09.63-.09c.28,0,.53.05.76.14.23.1.43.21.6.35l-.35.47c-.15-.11-.31-.21-.47-.28-.16-.07-.34-.11-.53-.11-.28,0-.48.06-.61.19-.13.13-.19.27-.19.44,0,.1.03.19.08.27.05.08.13.14.22.2s.19.11.31.15c.12.05.24.09.36.14.16.06.31.12.47.19.16.07.3.15.43.25s.23.22.31.36c.08.14.12.32.12.52,0,.18-.03.35-.1.5-.07.16-.17.29-.31.41-.14.12-.3.21-.5.28s-.43.1-.69.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.98,62.12c-.23,0-.43-.04-.59-.11s-.29-.17-.39-.3c-.1-.13-.17-.28-.21-.46-.04-.18-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04s.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.65,62.01v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23s-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.15,56.73c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM51.77,62.01v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.99,62.12c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.21,61.52c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.87,76.32v-5.9h.75v5.9h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.17,76.32v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23s-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M39.06,76.43c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM37.69,73.78h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.54,76.43c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.06,76.43c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.27,75.83c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.58,76.32v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55,76.43c-.55,0-.99-.2-1.32-.59-.33-.4-.49-.96-.49-1.69,0-.35.05-.67.16-.96.1-.28.24-.53.42-.72.17-.2.38-.35.6-.46.23-.11.47-.16.72-.16s.47.04.66.13c.19.09.38.21.57.37l-.04-.75v-1.68h.75v6.41h-.61l-.06-.51h-.03c-.17.17-.37.31-.6.44-.23.12-.47.18-.72.18ZM55.16,75.81c.2,0,.4-.05.58-.15.18-.1.36-.25.54-.45v-2.29c-.19-.17-.36-.29-.54-.36s-.35-.1-.53-.1-.34.04-.49.12c-.15.08-.29.19-.4.34-.11.15-.2.32-.27.53-.07.2-.1.43-.1.68,0,.53.1.94.31,1.23s.51.44.89.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M10.4,90.63v-5.9h.75v5.26h2.58v.64h-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M15.98,90.74c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.28.63.28.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.11h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58-.23.14-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M18.99,90.63l1.43-2.29-1.32-2.09h.8l.58.96c.07.12.13.24.21.37.07.12.15.24.22.36h.04c.07-.12.13-.24.2-.36.07-.12.13-.25.2-.37l.53-.96h.77l-1.32,2.17,1.42,2.21h-.8l-.64-1.02c-.08-.13-.16-.26-.23-.4-.08-.13-.16-.26-.24-.39h-.04c-.08.13-.15.25-.23.38-.07.13-.14.26-.22.4l-.59,1.02h-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M25.39,90.74c-.29,0-.57-.05-.82-.16-.25-.11-.48-.26-.67-.45-.19-.2-.34-.43-.45-.72-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41s.26.4.34.65.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.32-.23.09-.5.13-.8.13ZM24.01,88.09h2.34c0-.44-.09-.78-.28-1.01-.19-.23-.45-.35-.8-.35-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M28.08,90.63v-4.37h.61l.06.63h.03c.19-.21.4-.38.63-.53.23-.14.47-.21.73-.21.34,0,.6.07.79.22.19.15.33.35.42.62.23-.25.46-.46.69-.61.23-.15.48-.23.75-.23.45,0,.78.14,1,.43.22.29.33.71.33,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.61-.27-.33,0-.7.22-1.1.67v3.17h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.62-.27-.33,0-.7.22-1.1.67v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.47,90.74c-.2,0-.42-.05-.63-.15-.22-.1-.42-.24-.62-.41h-.03l-.06.45h-.59v-6.41h.74v1.75l-.02.79c.2-.17.41-.32.65-.44.23-.12.47-.17.72-.17.28,0,.53.05.75.16.22.11.4.25.54.45.15.19.26.43.33.7.07.27.11.58.11.91,0,.37-.05.71-.15,1-.1.29-.24.54-.41.75-.17.2-.38.36-.6.46-.23.1-.47.16-.72.16ZM37.35,90.12c.18,0,.35-.04.5-.12.15-.08.29-.2.4-.34.11-.15.2-.33.26-.54s.09-.46.09-.73c0-.24-.02-.46-.06-.66-.04-.2-.11-.37-.2-.51-.09-.14-.21-.25-.36-.33-.15-.08-.32-.12-.53-.12-.35,0-.74.2-1.17.59v2.29c.19.17.38.29.57.36s.36.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.22,90.74c-.27,0-.53-.05-.77-.15-.24-.1-.46-.25-.64-.45s-.33-.43-.45-.72c-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72s.4-.35.64-.45c.24-.1.5-.15.77-.15s.53.05.77.15c.24.1.46.25.64.45s.33.44.45.72c.11.29.17.61.17.98s-.06.68-.17.97c-.11.29-.26.52-.45.72s-.4.34-.64.45c-.24.1-.5.15-.77.15ZM42.22,90.13c.19,0,.36-.04.51-.12.16-.08.29-.2.4-.34.11-.15.2-.32.26-.53.06-.2.09-.43.09-.68s-.03-.48-.09-.69-.15-.39-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35-.11.15-.2.33-.26.54s-.09.44-.09.69.03.48.09.68c.06.2.15.38.26.53.11.15.24.26.4.34.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.67,90.74c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.28.63.28.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.11h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58-.23.14-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.29,90.63v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.22-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.89,92.65c-.27,0-.52-.03-.74-.08-.22-.05-.41-.13-.57-.23-.16-.1-.28-.22-.37-.37-.09-.14-.13-.31-.13-.5s.06-.36.17-.53c.11-.17.27-.32.47-.46v-.04c-.11-.07-.2-.16-.27-.27-.08-.12-.11-.26-.11-.44,0-.19.05-.35.15-.49s.21-.25.32-.32v-.04c-.14-.12-.27-.28-.39-.48-.12-.2-.18-.43-.18-.7,0-.24.04-.46.13-.65.09-.19.21-.36.36-.49.15-.13.33-.24.53-.31.2-.07.41-.11.63-.11.12,0,.23,0,.34.03s.2.05.28.08h1.52v.57h-.9c.1.1.19.23.26.39s.1.33.1.51c0,.23-.04.45-.13.63-.08.19-.2.35-.34.48s-.31.23-.51.3c-.19.07-.4.11-.63.11-.11,0-.22-.01-.33-.04-.11-.03-.22-.06-.32-.11-.08.07-.14.14-.2.22-.05.08-.08.18-.08.3,0,.14.05.25.16.34s.31.13.61.13h.85c.51,0,.89.08,1.15.25s.38.43.38.8c0,.2-.05.4-.15.58-.1.18-.25.34-.44.48-.19.14-.42.25-.7.33-.27.08-.58.12-.92.12ZM55,92.13c.21,0,.4-.03.57-.08s.32-.12.44-.2.21-.17.28-.28.1-.22.1-.33c0-.2-.08-.34-.23-.42s-.37-.12-.66-.12h-.76c-.08,0-.18,0-.27-.01s-.2-.03-.29-.06c-.16.11-.27.23-.34.36-.07.13-.11.25-.11.38,0,.23.11.42.34.56.23.14.54.21.93.21ZM54.89,88.75c.13,0,.24-.02.36-.07.11-.05.21-.12.3-.21.09-.09.15-.2.2-.33.05-.13.07-.27.07-.44,0-.32-.09-.57-.27-.75-.18-.18-.4-.27-.66-.27s-.48.09-.66.27c-.18.18-.27.43-.27.75,0,.16.02.31.07.44s.12.24.2.33c.09.09.19.16.3.21.11.05.23.07.36.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M22.73,104.94v-5.9h.75v5.26h2.58v.64h-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M27.41,99.67c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM27.03,104.94v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.62,105.05c-.23,0-.43-.04-.59-.11s-.29-.17-.39-.3c-.1-.13-.17-.28-.21-.46-.04-.18-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04s.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M32.28,104.94v-6.41h.74v1.75l-.03.9c.21-.2.43-.37.66-.51s.5-.21.8-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M38.46,105.05c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.27.63.27.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.1h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58s-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M43.08,105.05c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM43.3,104.46c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.61,104.94v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M51.91,99.67c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM51.53,104.94v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.76,105.05c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM54.97,104.46c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M35.58,119.25v-5.9h.75v5.26h2.58v.64h-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.89,119.36c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM41.1,118.77c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.79,119.36c-.23,0-.43-.04-.59-.11s-.29-.17-.39-.3c-.1-.13-.17-.28-.21-.46-.04-.18-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04s.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.4,119.25l-1.58-4.37h.77l.83,2.48c.07.22.13.43.2.65.07.22.14.43.2.64h.04c.07-.21.13-.42.2-.64.07-.22.13-.43.2-.65l.83-2.48h.73l-1.55,4.37h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.04,113.98c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM51.66,119.25v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.88,119.36c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.1,118.77c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.71,133.67c-.39,0-.75-.07-1.08-.21-.33-.14-.61-.34-.84-.6-.23-.26-.42-.58-.55-.96-.13-.38-.2-.81-.2-1.29s.07-.9.2-1.28c.14-.38.32-.7.56-.96.24-.26.53-.47.86-.61.33-.14.69-.21,1.08-.21.2,0,.39.02.56.06.17.04.33.1.47.17.14.07.27.15.38.23s.21.18.29.27l-.41.49c-.15-.16-.32-.29-.52-.4-.2-.11-.45-.16-.75-.16s-.57.06-.81.17c-.24.11-.44.27-.61.48s-.3.46-.39.75c-.09.29-.14.62-.14.99s.04.71.13,1c.09.3.21.55.38.76s.37.37.61.49c.24.11.52.17.84.17.21,0,.41-.03.6-.09.19-.06.34-.15.46-.26v-1.54h-1.25v-.62h1.94v2.48c-.19.2-.44.36-.76.49s-.67.19-1.06.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.87,133.56v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23s-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.77,133.67c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM41.39,131.02h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M47.23,133.67c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM45.85,131.02h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M51.65,133.67c-.29,0-.56-.05-.81-.15-.25-.1-.47-.25-.65-.45-.18-.19-.33-.43-.43-.72s-.16-.61-.16-.97.06-.69.17-.98c.11-.29.27-.53.46-.72.19-.2.42-.35.67-.45s.52-.15.81-.15.53.05.74.15.38.22.54.36l-.38.49c-.13-.11-.26-.21-.4-.28-.14-.07-.3-.11-.47-.11-.2,0-.38.04-.55.12s-.31.2-.43.35-.21.33-.28.54c-.07.21-.1.44-.1.69s.03.48.1.68c.07.2.16.38.27.53.12.15.26.26.43.34s.35.12.55.12.39-.04.56-.13c.17-.09.33-.19.46-.31l.32.49c-.2.17-.42.31-.66.41-.24.1-.49.15-.76.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.8,133.67c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM54.42,131.02h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-343"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.98,147.87v-5.9h1.68c.33,0,.63.03.9.09s.51.16.7.29c.19.13.34.31.45.54.11.22.16.49.16.82s-.05.58-.16.81-.25.42-.45.57-.42.26-.69.34c-.27.08-.56.11-.89.11h-.97v2.34h-.75ZM32.72,144.92h.88c.52,0,.9-.1,1.15-.29.25-.19.37-.5.37-.92s-.13-.72-.39-.89c-.26-.16-.65-.25-1.17-.25h-.85v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M38.7,147.98c-.27,0-.53-.05-.77-.15s-.46-.25-.64-.45c-.19-.19-.33-.43-.45-.72-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72.19-.2.4-.35.64-.45s.5-.15.77-.15.53.05.77.15.46.25.64.45c.19.2.33.44.45.72.11.28.17.61.17.98s-.06.68-.17.97c-.11.29-.26.52-.45.72-.19.2-.4.34-.64.45s-.5.15-.77.15ZM38.7,147.37c.19,0,.36-.04.51-.12.16-.08.29-.19.4-.34.11-.15.2-.32.26-.53.06-.2.09-.43.09-.68s-.03-.48-.09-.69-.15-.39-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35s-.2.33-.26.54-.09.44-.09.69.03.48.09.68c.06.2.15.38.26.53s.24.26.4.34c.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.66,147.98c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.18,147.98c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.4,147.39c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.71,147.87v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.12,147.98c-.55,0-.99-.2-1.32-.59-.33-.4-.49-.96-.49-1.69,0-.35.05-.67.16-.96.1-.28.24-.53.42-.72.17-.2.38-.35.6-.46.23-.11.47-.16.72-.16s.47.04.66.13c.19.09.38.21.57.37l-.04-.75v-1.68h.75v6.41h-.61l-.06-.51h-.03c-.17.17-.37.31-.6.44-.23.12-.47.18-.72.18ZM55.29,147.36c.2,0,.4-.05.58-.15.18-.1.36-.25.54-.45v-2.29c-.19-.17-.36-.29-.54-.36s-.35-.1-.53-.1-.34.04-.49.12c-.15.08-.29.19-.4.34-.11.15-.2.32-.27.53-.07.2-.1.43-.1.68,0,.53.1.94.31,1.23s.51.44.89.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M26.08,162.29c-.39,0-.75-.07-1.08-.21-.33-.14-.61-.34-.84-.6-.23-.26-.42-.58-.55-.96-.13-.38-.2-.81-.2-1.29s.07-.9.2-1.28c.14-.38.32-.7.56-.96.24-.26.53-.47.86-.61.33-.14.69-.21,1.08-.21.2,0,.39.02.56.06.17.04.33.1.47.17.14.07.27.15.38.23s.21.18.29.27l-.41.49c-.15-.16-.32-.29-.52-.4-.2-.11-.45-.16-.75-.16s-.57.06-.81.17c-.24.11-.44.27-.61.48s-.3.46-.39.75c-.09.29-.14.62-.14.99s.04.71.13,1c.09.3.21.55.38.76s.37.37.61.49c.24.11.52.17.84.17.21,0,.41-.03.6-.09.19-.06.34-.15.46-.26v-1.54h-1.25v-.62h1.94v2.48c-.19.2-.44.36-.76.49s-.67.19-1.06.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.01,162.29c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM29.64,159.65h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.7,162.19v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23s-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M36.83,162.19v-4.37h.61l.06.63h.03c.19-.21.4-.39.63-.53s.47-.21.73-.21c.34,0,.6.07.79.22.19.15.33.35.42.62.23-.25.46-.45.69-.61s.48-.23.75-.23c.45,0,.78.14,1,.43.22.29.33.71.33,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.61-.27-.33,0-.7.22-1.1.67v3.17h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.62-.27-.33,0-.7.22-1.1.67v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.3,162.29c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.51,161.7c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.82,162.19v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M53.82,164.07c-.1,0-.2,0-.28-.02s-.16-.04-.23-.07l.14-.58s.1.03.16.04c.06.01.12.02.17.02.25,0,.46-.09.62-.27.16-.18.28-.4.37-.67l.1-.32-1.75-4.38h.77l.89,2.42c.07.19.14.39.21.61.07.21.15.42.21.63h.04c.07-.2.13-.4.19-.62.06-.22.12-.42.18-.61l.78-2.42h.72l-1.65,4.73c-.08.22-.17.42-.26.6-.1.19-.21.35-.34.48-.13.14-.28.24-.45.32-.17.08-.36.12-.58.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.56,176.5v-5.9h3.4v.63h-2.65v1.85h2.24v.64h-2.24v2.14h2.74v.64h-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M36.37,176.6c-.31,0-.61-.06-.89-.17-.28-.11-.53-.26-.74-.43l.37-.5c.19.16.39.28.59.38.2.1.43.14.7.14.29,0,.5-.07.65-.2s.22-.29.22-.49c0-.11-.03-.21-.09-.3-.06-.08-.14-.16-.23-.22-.09-.06-.2-.12-.32-.17s-.24-.1-.36-.14c-.16-.05-.31-.12-.47-.18-.16-.07-.3-.15-.42-.25-.12-.1-.22-.21-.3-.35-.08-.13-.12-.29-.12-.48,0-.17.03-.34.1-.49.07-.15.17-.29.3-.4.13-.11.29-.2.47-.26s.4-.09.63-.09c.28,0,.53.05.76.14.23.1.43.21.6.35l-.35.47c-.15-.11-.31-.21-.47-.28-.16-.07-.34-.11-.53-.11-.28,0-.48.06-.61.19-.13.13-.19.27-.19.44,0,.1.03.19.08.27.05.08.13.14.22.2s.19.11.31.15c.12.05.24.09.36.14.16.06.31.12.47.19.16.07.3.15.43.25s.23.22.31.36c.08.14.12.32.12.52,0,.18-.03.35-.1.5-.07.16-.17.29-.31.41-.14.12-.3.21-.5.28s-.43.1-.69.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.37,176.6c-.23,0-.43-.04-.59-.11s-.29-.17-.39-.3c-.1-.13-.17-.28-.21-.46-.04-.18-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04s.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M43.74,176.6c-.27,0-.53-.05-.77-.15s-.46-.25-.64-.45c-.19-.19-.33-.43-.45-.72-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72.19-.2.4-.35.64-.45s.5-.15.77-.15.53.05.77.15.46.25.64.45c.19.2.33.44.45.72.11.28.17.61.17.98s-.06.68-.17.97c-.11.29-.26.52-.45.72-.19.2-.4.34-.64.45s-.5.15-.77.15ZM43.74,175.99c.19,0,.36-.04.51-.12.16-.08.29-.19.4-.34.11-.15.2-.32.26-.53.06-.2.09-.43.09-.68s-.03-.48-.09-.69-.15-.39-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35s-.2.33-.26.54-.09.44-.09.69.03.48.09.68c.06.2.15.38.26.53s.24.26.4.34c.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.92,176.5v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.22,171.22c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM51.84,176.5v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.06,176.6c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.28,176.01c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.77,190.81v-5.9h.75v5.9h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.44,190.92c-.23,0-.43-.04-.59-.11s-.29-.17-.39-.3c-.1-.13-.17-.28-.21-.46-.04-.18-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04s.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.11,190.92c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM48.33,190.32c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.42,190.92c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.01,192.69c-.1,0-.2,0-.28-.02s-.16-.04-.23-.07l.14-.58s.1.03.16.04c.06.01.12.02.17.02.25,0,.46-.09.62-.27.16-.18.28-.4.37-.67l.1-.32-1.75-4.38h.77l.89,2.42c.07.19.14.39.21.61.07.21.15.42.21.63h.04c.07-.2.13-.4.19-.62.06-.22.12-.42.18-.61l.78-2.42h.72l-1.65,4.73c-.08.22-.17.42-.26.6-.1.19-.21.35-.34.48-.13.14-.28.24-.45.32-.17.08-.36.12-.58.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-291"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M3.04,205.23c-.37,0-.71-.07-1.03-.21-.31-.14-.58-.34-.81-.6-.23-.26-.41-.58-.54-.96-.13-.38-.19-.81-.19-1.29s.07-.9.2-1.28.31-.7.55-.96c.23-.26.51-.47.83-.61.32-.14.67-.21,1.04-.21s.68.07.95.22c.27.15.5.32.67.51l-.41.49c-.16-.17-.33-.3-.53-.41-.2-.1-.42-.15-.67-.15-.28,0-.54.06-.77.17s-.42.27-.58.48-.29.46-.37.75-.13.62-.13.99.04.71.13,1c.09.3.21.55.36.76.16.21.35.37.57.49.23.11.48.17.76.17s.54-.06.76-.18c.22-.12.42-.28.61-.49l.41.47c-.23.27-.5.48-.79.63s-.63.23-1.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M5.42,205.12v-.4l2.3-3.38h-2.05v-.6h2.99v.4l-2.3,3.38h2.38v.6h-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M11.48,205.23c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM10.1,202.58h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M15.89,205.23c-.29,0-.56-.05-.81-.15-.25-.1-.47-.25-.65-.45-.18-.19-.33-.43-.43-.72s-.16-.61-.16-.97.06-.69.17-.98c.11-.29.27-.53.46-.72.19-.2.42-.35.67-.45s.52-.15.81-.15.53.05.74.15.38.22.54.36l-.38.49c-.13-.11-.26-.21-.4-.28-.14-.07-.3-.11-.47-.11-.2,0-.38.04-.55.12s-.31.2-.43.35-.21.33-.28.54c-.07.21-.1.44-.1.69s.03.48.1.68c.07.2.16.38.27.53.12.15.26.26.43.34s.35.12.55.12.39-.04.56-.13c.17-.09.33-.19.46-.31l.32.49c-.2.17-.42.31-.66.41-.24.1-.49.15-.76.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M18.27,205.12v-6.41h.74v1.75l-.03.9c.21-.2.43-.37.66-.51s.5-.21.8-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M25.04,205.12v-5.9h1.84c.3,0,.58.03.83.09.26.06.47.15.66.28.18.13.33.3.43.51s.15.47.15.77c0,.46-.12.83-.36,1.11-.24.28-.56.47-.97.57l1.5,2.57h-.85l-1.42-2.49h-1.07v2.49h-.75ZM25.78,202.01h.99c.46,0,.82-.09,1.06-.28s.37-.48.37-.86-.12-.66-.37-.82c-.25-.16-.6-.23-1.06-.23h-.99v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.86,205.23c-.29,0-.57-.05-.82-.16-.25-.1-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31-.23.09-.5.13-.8.13ZM30.48,202.58h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.55,206.96v-6.22h.61l.06.5h.03c.2-.17.42-.31.65-.43.24-.12.48-.18.74-.18.28,0,.53.05.75.16.22.11.4.26.54.45s.25.43.33.7c.07.27.11.58.11.92,0,.37-.05.7-.15.99-.1.29-.24.54-.41.74-.17.2-.38.36-.6.46-.23.1-.47.16-.72.16-.2,0-.41-.04-.61-.13-.2-.09-.4-.21-.61-.37l.02.77v1.48h-.74ZM36.36,204.6c.18,0,.35-.04.5-.12.15-.08.29-.2.4-.34s.2-.33.26-.54.09-.46.09-.73c0-.24-.02-.46-.06-.66-.04-.2-.11-.37-.2-.51-.09-.14-.21-.25-.36-.33-.15-.08-.32-.12-.53-.12-.19,0-.37.05-.56.15s-.39.25-.61.44v2.29c.2.17.39.29.58.36.19.07.35.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.82,205.23c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.27.63.27.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.1h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58s-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.38,205.23c-.2,0-.42-.05-.63-.15-.22-.1-.42-.24-.62-.41h-.03l-.06.45h-.59v-6.41h.74v1.75l-.02.79c.2-.17.41-.32.65-.44.23-.12.47-.18.72-.18.28,0,.53.05.75.16.22.11.4.26.54.45.15.19.26.43.33.7.07.27.11.58.11.91,0,.37-.05.71-.15,1-.1.29-.24.54-.41.75-.17.2-.38.36-.6.46-.23.1-.47.16-.72.16ZM46.25,204.6c.18,0,.35-.04.5-.12.15-.08.29-.2.4-.34s.2-.33.26-.54.09-.46.09-.73c0-.24-.02-.46-.06-.66-.04-.2-.11-.37-.2-.51-.09-.14-.21-.25-.36-.33-.15-.08-.32-.12-.53-.12-.35,0-.74.2-1.17.59v2.29c.19.17.38.29.57.36.19.07.36.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.2,205.23c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.09,199.84c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM51.71,205.12v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.65,205.23c-.29,0-.56-.05-.81-.15-.25-.1-.47-.25-.65-.45-.18-.19-.33-.43-.43-.72s-.16-.61-.16-.97.06-.69.17-.98c.11-.29.27-.53.46-.72.19-.2.42-.35.67-.45s.52-.15.81-.15.53.05.74.15.38.22.54.36l-.38.49c-.13-.11-.26-.21-.4-.28-.14-.07-.3-.11-.47-.11-.2,0-.38.04-.55.12s-.31.2-.43.35-.21.33-.28.54c-.07.21-.1.44-.1.69s.03.48.1.68c.07.2.16.38.27.53.12.15.26.26.43.34s.35.12.55.12.39-.04.56-.13c.17-.09.33-.19.46-.31l.32.49c-.2.17-.42.31-.66.41-.24.1-.49.15-.76.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M47.74,219.43v-5.9h3.4v.63h-2.65v1.85h2.24v.64h-2.24v2.14h2.74v.64h-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.58,219.54c-.3,0-.58-.04-.84-.13-.26-.09-.49-.23-.67-.43-.19-.2-.34-.46-.45-.79-.11-.32-.16-.72-.16-1.2v-3.46h.75v3.48c0,.35.04.65.11.89.07.24.17.43.29.58.12.14.27.25.44.31.17.06.35.09.54.09s.38-.03.55-.09.31-.17.44-.31.23-.34.3-.58c.07-.24.11-.54.11-.89v-3.48h.72v3.46c0,.47-.05.87-.16,1.2-.11.32-.26.59-.45.79-.19.2-.41.35-.67.43-.26.09-.54.13-.84.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M27.32,233.74v-5.9h1.75c.3,0,.57.03.82.08.25.05.46.14.64.25.18.11.31.26.41.45.1.18.15.4.15.66,0,.29-.07.56-.22.8-.15.24-.36.4-.64.49v.04c.36.07.65.22.87.45.22.23.33.55.33.96,0,.29-.05.54-.16.76s-.26.4-.46.54c-.2.14-.44.25-.71.32-.28.07-.58.11-.91.11h-1.88ZM28.07,230.35h.87c.5,0,.87-.09,1.09-.26.22-.17.33-.41.33-.71,0-.34-.12-.58-.35-.73s-.58-.22-1.04-.22h-.91v1.92ZM28.07,233.15h1.03c.51,0,.91-.09,1.19-.28.28-.19.42-.48.42-.88,0-.37-.14-.63-.41-.81s-.67-.26-1.2-.26h-1.03v2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.31,233.85c-.29,0-.57-.05-.82-.16-.25-.11-.48-.26-.67-.45-.19-.2-.34-.43-.45-.72-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41s.26.4.34.65.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.32-.23.09-.5.13-.8.13ZM32.94,231.2h2.34c0-.44-.09-.78-.28-1.01-.19-.23-.45-.35-.8-.35-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.79,233.85c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.77,235.76c-.27,0-.52-.03-.74-.08-.22-.05-.41-.13-.57-.23-.16-.1-.28-.22-.37-.37-.09-.14-.13-.31-.13-.5s.06-.36.17-.53c.11-.17.27-.32.47-.46v-.04c-.11-.07-.2-.16-.27-.27-.08-.12-.11-.26-.11-.44,0-.19.05-.35.15-.49s.21-.25.32-.32v-.04c-.14-.12-.27-.28-.39-.48-.12-.2-.18-.43-.18-.7,0-.24.04-.46.13-.65.09-.19.21-.36.36-.49.15-.13.33-.24.53-.31.2-.07.41-.11.63-.11.12,0,.23,0,.34.03s.2.05.28.08h1.52v.57h-.9c.1.1.19.23.26.39s.1.33.1.51c0,.23-.04.45-.13.63-.08.19-.2.35-.34.48s-.31.23-.51.3c-.19.07-.4.11-.63.11-.11,0-.22-.01-.33-.04-.11-.03-.22-.06-.32-.11-.08.07-.14.14-.2.22-.05.08-.08.18-.08.3,0,.14.05.25.16.34s.31.13.61.13h.85c.51,0,.89.08,1.15.25s.38.43.38.8c0,.2-.05.4-.15.58-.1.18-.25.34-.44.48-.19.14-.42.25-.7.33-.27.08-.58.12-.92.12ZM40.88,235.24c.21,0,.4-.03.57-.08s.32-.12.44-.2.21-.17.28-.28.1-.22.1-.33c0-.2-.08-.34-.23-.42s-.37-.12-.66-.12h-.76c-.08,0-.18,0-.27-.01s-.2-.03-.29-.06c-.16.11-.27.23-.34.36-.07.13-.11.25-.11.38,0,.23.11.42.34.56.23.14.54.21.93.21ZM40.77,231.86c.13,0,.24-.02.36-.07.11-.05.21-.12.3-.21.09-.09.15-.2.2-.33.05-.13.07-.27.07-.44,0-.32-.09-.57-.27-.75-.18-.18-.4-.27-.66-.27s-.48.09-.66.27c-.18.18-.27.43-.27.75,0,.16.02.31.07.44s.12.24.2.33c.09.09.19.16.3.21.11.05.23.07.36.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M44.21,228.47c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM43.83,233.74v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M47.33,233.85c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.28.63.28.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.11h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58-.23.14-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.94,233.74v-4.37h.61l.06.63h.03c.19-.21.4-.38.63-.53.23-.14.47-.21.73-.21.34,0,.6.07.79.22.19.15.33.35.42.62.23-.25.46-.46.69-.61.23-.15.48-.23.75-.23.45,0,.78.14,1,.43.22.29.33.71.33,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.61-.27-.33,0-.7.22-1.1.67v3.17h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.62-.27-.33,0-.7.22-1.1.67v3.17h-.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-283"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.27,248.05v-5.9h3.4v.63h-2.65v2h2.25v.63h-2.25v2.65h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.65,248.05v-4.37h.61l.06.79h.03c.15-.28.33-.49.54-.66s.45-.24.7-.24c.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.78,248.16c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM41.99,247.57c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.21c-.37.05-.67.1-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.31,248.05v-4.37h.61l.06.63h.03c.21-.21.43-.38.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M51.96,248.16c-.29,0-.56-.05-.81-.15-.25-.1-.47-.25-.65-.45s-.33-.43-.43-.72-.16-.61-.16-.97.06-.69.17-.98.27-.53.46-.72c.19-.2.42-.35.67-.45.25-.1.52-.15.81-.15s.53.05.74.15c.2.1.38.22.54.36l-.38.49c-.13-.11-.26-.21-.4-.28s-.3-.11-.47-.11c-.2,0-.38.04-.55.12s-.31.2-.43.35-.21.33-.28.54c-.07.21-.1.44-.1.69s.03.48.1.68c.07.21.16.38.27.53.12.15.26.26.43.34s.35.12.55.12.39-.04.56-.13c.17-.09.33-.19.46-.31l.32.5c-.2.17-.42.31-.66.41-.24.1-.49.15-.76.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M56.11,248.16c-.29,0-.57-.05-.82-.16-.25-.11-.48-.26-.67-.45s-.34-.43-.45-.72c-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.29.26-.53.44-.72.18-.2.39-.35.63-.46.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41s.26.4.34.65.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.32-.23.09-.5.13-.8.13ZM54.73,245.51h2.34c0-.44-.09-.78-.28-1.01s-.45-.35-.8-.35c-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.04,262.47c-.41,0-.8-.08-1.15-.23s-.66-.37-.92-.64l.45-.52c.21.22.46.4.74.54.29.13.58.2.89.2.39,0,.69-.09.91-.27.22-.18.32-.41.32-.7,0-.15-.03-.28-.08-.38-.05-.1-.12-.19-.21-.27-.09-.07-.19-.14-.31-.2-.12-.06-.25-.12-.39-.19l-.85-.37c-.14-.06-.28-.13-.42-.22s-.27-.19-.39-.3c-.11-.12-.21-.26-.28-.43-.07-.17-.11-.36-.11-.57s.05-.43.14-.62c.09-.19.22-.36.39-.5s.36-.25.58-.33c.23-.08.47-.12.74-.12.35,0,.68.07.98.2.3.13.55.31.77.53l-.41.49c-.18-.17-.38-.31-.6-.41-.22-.1-.47-.15-.74-.15-.33,0-.6.08-.8.23-.2.15-.3.37-.3.63,0,.14.03.27.09.37.06.1.13.19.23.26.1.08.2.14.31.2.11.06.23.11.35.16l.84.36c.17.07.33.15.48.25s.28.2.39.32c.11.12.19.27.26.43s.09.36.09.57c0,.23-.05.45-.14.66s-.23.38-.4.54c-.17.15-.38.27-.63.36-.25.09-.53.13-.84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.83,262.36l-1.22-4.37h.76l.65,2.53c.05.21.09.41.13.61.04.2.08.4.13.6h.04c.05-.2.1-.41.14-.61.05-.2.1-.4.15-.61l.68-2.53h.72l.68,2.53c.05.21.11.41.16.61.05.2.1.4.15.6h.04c.05-.2.09-.41.14-.6.04-.2.09-.4.13-.61l.64-2.53h.7l-1.17,4.37h-.9l-.63-2.35c-.05-.21-.1-.42-.15-.62-.04-.2-.09-.42-.15-.64h-.04c-.05.22-.1.44-.14.64-.05.21-.1.42-.16.63l-.61,2.34h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.37,262.47c-.29,0-.57-.05-.82-.16-.25-.1-.48-.25-.67-.45-.19-.2-.34-.43-.45-.72-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.29.26-.53.44-.72.18-.2.39-.35.63-.46.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.54.12.85c0,.08,0,.16,0,.23,0,.07-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.1.18-.06.35-.14.51-.25l.26.49c-.19.12-.41.22-.64.32-.23.09-.5.13-.8.13ZM40,259.82h2.34c0-.44-.09-.78-.28-1.01-.19-.23-.45-.35-.8-.35-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.56,262.47c-.55,0-.99-.2-1.32-.59-.33-.4-.49-.96-.49-1.69,0-.35.05-.67.16-.96.1-.28.24-.53.42-.72.17-.2.38-.35.6-.46.23-.11.47-.16.72-.16s.47.04.66.13.38.21.57.37l-.04-.75v-1.68h.75v6.41h-.61l-.06-.51h-.03c-.17.17-.37.31-.6.44-.23.12-.47.19-.72.19ZM45.72,261.85c.2,0,.4-.05.58-.15.18-.1.36-.25.54-.46v-2.29c-.19-.17-.36-.29-.54-.36-.17-.07-.35-.1-.53-.1s-.34.04-.49.12c-.15.08-.29.2-.4.34-.11.15-.2.32-.27.53-.07.2-.1.43-.1.68,0,.53.1.94.31,1.23s.51.44.89.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.83,262.47c-.29,0-.57-.05-.82-.16-.25-.1-.48-.25-.67-.45-.19-.2-.34-.43-.45-.72-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.29.26-.53.44-.72.18-.2.39-.35.63-.46.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.54.12.85c0,.08,0,.16,0,.23,0,.07-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.1.18-.06.35-.14.51-.25l.26.49c-.19.12-.41.22-.64.32-.23.09-.5.13-.8.13ZM49.45,259.82h2.34c0-.44-.09-.78-.28-1.01-.19-.23-.45-.35-.8-.35-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M53.52,262.36v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53s.5-.21.81-.21c.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-304"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.15,276.67v-5.9h3.4v.63h-2.65v2h2.25v.63h-2.25v2.65h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.91,271.4c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM34.53,276.67v-4.38h.74v4.38h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M36.74,276.67v-4.38h.61l.06.63h.03c.21-.21.43-.39.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.89-.13-.18-.34-.28-.63-.28-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.45,276.78c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M44.97,276.78c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.26,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.1-.45-.1-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.18,276.19c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.22c-.37.05-.67.11-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54s.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.49,276.67v-4.38h.61l.06.63h.03c.21-.21.43-.39.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.89-.13-.18-.34-.28-.63-.28-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.91,276.78c-.55,0-.99-.2-1.32-.59-.33-.4-.49-.96-.49-1.69,0-.35.05-.67.16-.96s.24-.53.42-.72c.17-.2.38-.35.6-.46.23-.11.47-.16.72-.16s.47.04.66.13.38.21.57.37l-.04-.75v-1.68h.75v6.41h-.61l-.06-.51h-.03c-.17.17-.37.31-.6.44-.23.12-.47.18-.72.18ZM55.07,276.16c.2,0,.4-.05.58-.15.18-.1.36-.25.54-.46v-2.29c-.19-.17-.36-.29-.54-.36s-.35-.1-.53-.1-.34.04-.49.12c-.15.08-.29.2-.4.34-.11.15-.2.32-.27.53-.07.2-.1.43-.1.68,0,.53.1.94.31,1.23.21.29.51.44.89.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M27.75,291.09c-.41,0-.8-.08-1.15-.23-.35-.16-.66-.37-.92-.64l.45-.52c.21.22.46.4.74.54.29.13.58.2.89.2.39,0,.69-.09.91-.27.22-.18.32-.41.32-.7,0-.15-.03-.28-.08-.38-.05-.11-.12-.2-.21-.27-.09-.07-.19-.14-.31-.2-.12-.06-.25-.12-.39-.19l-.85-.37c-.14-.06-.28-.13-.42-.22s-.27-.19-.39-.31c-.11-.12-.21-.26-.28-.43-.07-.17-.11-.36-.11-.57s.05-.43.14-.62c.09-.19.22-.36.39-.5.17-.14.36-.25.58-.33.23-.08.47-.12.74-.12.35,0,.68.07.98.2.3.13.55.31.77.53l-.41.49c-.18-.17-.38-.31-.6-.41-.22-.1-.47-.15-.74-.15-.33,0-.6.08-.8.23-.2.15-.3.36-.3.63,0,.14.03.27.09.36.06.1.13.19.23.26.1.08.2.14.31.2.11.06.23.11.35.16l.84.36c.17.07.33.15.48.25.15.09.28.2.39.32.11.12.19.27.26.43s.09.36.09.57c0,.23-.05.45-.14.66s-.23.38-.4.54c-.17.15-.38.27-.63.36-.25.09-.53.13-.84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.63,291.09c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25s.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.84,291.09c-.27,0-.53-.05-.77-.15-.24-.1-.46-.25-.64-.45-.19-.19-.33-.43-.45-.72-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72.19-.2.4-.35.64-.45.24-.1.5-.15.77-.15s.53.05.77.15c.24.1.46.25.64.45.19.2.33.44.45.72.11.28.17.61.17.98s-.06.68-.17.97c-.11.29-.26.53-.45.72-.19.2-.4.34-.64.45-.24.1-.5.15-.77.15ZM34.84,290.48c.19,0,.36-.04.51-.12.16-.08.29-.19.4-.34.11-.15.2-.32.26-.53s.09-.43.09-.68-.03-.48-.09-.69-.15-.38-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35-.11.15-.2.33-.26.54s-.09.44-.09.69.03.48.09.68.15.38.26.53c.11.15.24.26.4.34.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M38.96,290.98l-1.58-4.37h.77l.83,2.48c.07.22.13.43.2.65s.14.43.2.64h.04c.07-.21.13-.42.2-.64s.13-.43.2-.65l.83-2.48h.73l-1.55,4.37h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M43.99,291.09c-.29,0-.57-.05-.82-.16s-.48-.25-.67-.45c-.19-.19-.34-.43-.45-.71-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.29.26-.53.44-.72s.39-.35.63-.46c.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41.15.18.26.4.34.65s.12.53.12.85c0,.08,0,.16,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.31s-.5.13-.8.13ZM42.61,288.45h2.34c0-.44-.09-.78-.28-1.01-.19-.23-.45-.35-.8-.35-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.68,290.98v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M51.98,285.71c-.14,0-.27-.04-.36-.13s-.15-.2-.15-.34c0-.14.05-.26.15-.35s.22-.13.36-.13.27.04.36.13.15.2.15.35-.05.25-.15.34-.22.13-.36.13ZM51.61,290.98v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.83,291.09c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.04,290.5c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M23.11,305.29v-5.9h1.48c.91,0,1.6.25,2.08.76.47.5.71,1.23.71,2.17,0,.47-.06.89-.18,1.25-.12.37-.3.68-.53.94-.23.25-.52.45-.86.58s-.73.2-1.18.2h-1.51ZM23.86,304.68h.67c.69,0,1.21-.21,1.55-.62.34-.41.52-1,.52-1.75s-.17-1.32-.52-1.72c-.35-.4-.86-.59-1.55-.59h-.67v4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.35,305.4c-.29,0-.57-.05-.82-.16-.25-.11-.48-.26-.67-.45-.19-.2-.34-.43-.45-.72-.11-.28-.16-.6-.16-.96s.06-.68.17-.97c.11-.28.26-.53.44-.72.18-.2.39-.35.63-.45.23-.1.48-.16.73-.16.28,0,.52.05.74.14.22.1.4.23.55.41s.26.4.34.65.12.53.12.85c0,.08,0,.15,0,.23,0,.08-.01.14-.02.19h-2.95c.03.47.18.84.44,1.11.26.27.6.41,1.02.41.21,0,.4-.03.58-.09.18-.06.35-.15.51-.25l.26.49c-.19.12-.41.22-.64.32-.23.09-.5.13-.8.13ZM28.97,302.76h2.34c0-.44-.09-.78-.28-1.01-.19-.23-.45-.35-.8-.35-.16,0-.3.03-.45.09-.14.06-.27.15-.38.27s-.21.26-.28.43c-.08.17-.12.36-.15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.04,305.29v-4.37h.61l.06.63h.03c.21-.21.43-.38.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43s.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.96,305.29v-4.37h.61l.06.63h.03c.19-.21.4-.38.63-.53.23-.14.47-.21.73-.21.34,0,.6.07.79.22.19.15.33.35.42.62.23-.25.46-.46.69-.61.23-.15.48-.23.75-.23.45,0,.78.14,1,.43.22.29.33.71.33,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.61-.27-.33,0-.7.22-1.1.67v3.17h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.62-.27-.33,0-.7.22-1.1.67v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.43,305.4c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM46.65,304.81c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M49.96,305.29v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.22-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M53.08,305.29v-6.41h.73v4.34h.03l1.86-2.3h.82l-1.47,1.75,1.67,2.62h-.81l-1.28-2.11-.82.95v1.15h-.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M24.78,319.61v-5.9h1.84c.3,0,.58.03.83.09.26.06.47.15.66.28s.33.3.43.51.15.47.15.77c0,.46-.12.83-.36,1.11-.24.28-.56.47-.97.57l1.5,2.57h-.85l-1.42-2.49h-1.07v2.49h-.75ZM25.52,316.5h.99c.46,0,.82-.09,1.06-.28.25-.19.37-.48.37-.86s-.12-.66-.37-.82-.6-.23-1.06-.23h-.99v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M31.53,319.71c-.27,0-.53-.05-.77-.15-.24-.1-.46-.25-.64-.45-.19-.19-.33-.43-.45-.72-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72.19-.2.4-.35.64-.45.24-.1.5-.15.77-.15s.53.05.77.15c.24.1.46.25.64.45.19.2.33.44.45.72.11.28.17.61.17.98s-.06.68-.17.97c-.11.29-.26.53-.45.72-.19.2-.4.34-.64.45-.24.1-.5.15-.77.15ZM31.53,319.1c.19,0,.36-.04.51-.12.16-.08.29-.19.4-.34.11-.15.2-.32.26-.53s.09-.43.09-.68-.03-.48-.09-.69-.15-.38-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35-.11.15-.2.33-.26.54s-.09.44-.09.69.03.48.09.68.15.38.26.53c.11.15.24.26.4.34.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M34.7,319.61v-4.37h.61l.06.63h.03c.19-.21.4-.39.63-.53.23-.14.47-.21.73-.21.34,0,.6.07.79.22s.33.35.42.62c.23-.25.46-.45.69-.61.23-.15.48-.23.75-.23.45,0,.78.14,1,.43.22.29.33.71.33,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.61-.27-.33,0-.7.22-1.1.67v3.17h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.62-.27-.33,0-.7.22-1.1.67v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M43.17,319.71c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM43.39,319.12c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.7,319.61v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52,314.33c-.14,0-.27-.04-.36-.13s-.15-.2-.15-.34c0-.14.05-.26.15-.35s.22-.13.36-.13.27.04.36.13.15.2.15.35-.05.25-.15.34-.22.13-.36.13ZM51.62,319.61v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.85,319.71c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.06,319.12c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.46,334.03c-.37,0-.71-.07-1.03-.21s-.58-.34-.81-.6c-.23-.26-.41-.58-.54-.96-.13-.38-.19-.81-.19-1.29s.07-.9.2-1.28.31-.7.55-.96c.23-.26.51-.47.83-.61.32-.14.67-.21,1.04-.21s.68.07.95.22c.27.15.5.32.67.51l-.41.49c-.16-.17-.33-.3-.53-.41-.2-.1-.42-.15-.67-.15-.28,0-.54.06-.77.17-.23.11-.42.27-.58.48s-.29.46-.37.75-.13.62-.13.99.04.71.13,1c.09.3.21.55.36.76.16.21.35.37.57.49s.48.17.76.17.54-.06.76-.18c.22-.12.42-.28.61-.49l.41.47c-.23.27-.5.48-.79.63-.29.15-.63.23-1.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M36.3,333.92v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.22-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.12,334.03c-.27,0-.53-.05-.77-.15-.24-.1-.46-.25-.64-.45s-.33-.43-.45-.72c-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72s.4-.35.64-.45c.24-.1.5-.15.77-.15s.53.05.77.15c.24.1.46.25.64.45s.33.44.45.72c.11.29.17.61.17.98s-.06.68-.17.97c-.11.29-.26.52-.45.72s-.4.34-.64.45c-.24.1-.5.15-.77.15ZM41.12,333.41c.19,0,.36-.04.51-.12.16-.08.29-.2.4-.34.11-.15.2-.32.26-.53.06-.2.09-.43.09-.68s-.03-.48-.09-.69-.15-.39-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35-.11.15-.2.33-.26.54s-.09.44-.09.69.03.48.09.68c.06.2.15.38.26.53.11.15.24.26.4.34.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.31,334.03c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.52,333.43c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.21,334.03c-.23,0-.43-.04-.59-.11-.16-.07-.29-.17-.39-.3-.1-.13-.17-.28-.21-.46s-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04.09-.02.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.25,328.64c-.14,0-.27-.04-.36-.14-.1-.09-.15-.2-.15-.34s.05-.26.15-.35c.1-.09.22-.13.36-.13s.27.04.36.13c.1.09.15.2.15.35s-.05.25-.15.34c-.1.09-.22.14-.36.14ZM51.88,333.92v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M55.1,334.03c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.31,333.43c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M27.07,348.23v-5.9h1.75c.3,0,.57.03.82.08.25.05.46.14.64.25.18.11.31.26.41.45.1.18.15.4.15.66,0,.29-.07.56-.22.8-.15.24-.36.4-.64.49v.04c.36.07.65.22.87.45.22.23.33.56.33.96,0,.29-.05.54-.16.76-.11.22-.26.4-.46.54-.2.14-.44.25-.71.32-.28.07-.58.11-.91.11h-1.88ZM27.82,344.83h.87c.5,0,.87-.09,1.09-.26.22-.17.33-.41.33-.71,0-.34-.12-.58-.35-.73-.23-.14-.58-.22-1.04-.22h-.91v1.92ZM27.82,347.63h1.03c.51,0,.91-.09,1.19-.28.28-.19.42-.48.42-.88,0-.37-.14-.63-.41-.81s-.67-.26-1.2-.26h-1.03v2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M33.57,348.34c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.27.63.27.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.1h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58-.23.14-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.97,348.34c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25s.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.96,350.24c-.27,0-.52-.03-.74-.08-.22-.05-.41-.13-.57-.23-.16-.1-.28-.23-.37-.37-.09-.14-.13-.31-.13-.5s.06-.36.17-.53c.11-.17.27-.32.47-.46v-.04c-.11-.07-.2-.16-.27-.27-.08-.12-.11-.26-.11-.44,0-.19.05-.35.15-.49.1-.14.21-.25.32-.32v-.04c-.14-.12-.27-.28-.39-.48-.12-.2-.18-.43-.18-.7,0-.24.04-.46.13-.65s.21-.36.36-.49c.15-.14.33-.24.53-.31.2-.07.41-.11.63-.11.12,0,.23.01.34.03.1.02.2.05.28.08h1.52v.57h-.9c.1.1.19.23.26.39s.1.33.1.51c0,.23-.04.45-.13.63-.08.19-.2.35-.34.48s-.31.23-.51.3-.4.11-.63.11c-.11,0-.22-.01-.33-.04-.11-.03-.22-.06-.32-.11-.08.07-.14.14-.2.22-.05.08-.08.18-.08.3,0,.14.05.25.16.34.11.09.31.13.61.13h.85c.51,0,.89.08,1.15.25s.38.43.38.8c0,.2-.05.4-.15.58-.1.18-.25.34-.44.48-.19.14-.42.25-.7.33-.27.08-.58.12-.92.12ZM41.07,349.73c.21,0,.4-.03.57-.08.17-.05.32-.12.44-.2s.21-.18.28-.28c.07-.11.1-.22.1-.33,0-.2-.08-.34-.23-.42s-.37-.12-.66-.12h-.76c-.08,0-.18,0-.27-.01-.1,0-.2-.03-.29-.06-.16.11-.27.23-.34.36-.07.13-.11.25-.11.38,0,.23.11.42.34.56.23.14.54.21.93.21ZM40.96,346.35c.13,0,.24-.02.36-.07.11-.05.21-.12.3-.21.09-.09.15-.2.2-.33.05-.13.07-.28.07-.44,0-.32-.09-.58-.27-.75-.18-.18-.4-.27-.66-.27s-.48.09-.66.27c-.18.18-.27.43-.27.75,0,.16.02.31.07.44.05.13.12.24.2.33s.19.16.3.21.23.07.36.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.03,348.34c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.24,347.74c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.55,348.23v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66s.45-.24.7-.24c.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.23-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.06,342.95c-.14,0-.27-.04-.36-.13s-.15-.2-.15-.34c0-.14.05-.26.15-.35s.22-.13.36-.13.27.04.36.13.15.2.15.35-.05.25-.15.34-.22.13-.36.13ZM51.68,348.23v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.9,348.34c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.12,347.74c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M25.86,362.54v-5.9h.75v2.47h2.74v-2.47h.76v5.9h-.76v-2.78h-2.74v2.78h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M32.93,362.65c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.28.63.28.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.11h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58-.23.14-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M36.55,362.54v-4.37h.61l.06.63h.03c.21-.21.43-.38.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43s.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M42.95,364.56c-.27,0-.52-.03-.74-.08-.22-.05-.41-.13-.57-.23-.16-.1-.28-.22-.37-.37-.09-.14-.13-.31-.13-.5s.06-.36.17-.53c.11-.17.27-.32.47-.46v-.04c-.11-.07-.2-.16-.27-.27-.08-.12-.11-.26-.11-.44,0-.19.05-.35.15-.49s.21-.25.32-.32v-.04c-.14-.12-.27-.28-.39-.48-.12-.2-.18-.43-.18-.7,0-.24.04-.46.13-.65.09-.19.21-.36.36-.49.15-.13.33-.24.53-.31.2-.07.41-.11.63-.11.12,0,.23,0,.34.03s.2.05.28.08h1.52v.57h-.9c.1.1.19.23.26.39s.1.33.1.51c0,.23-.04.45-.13.63-.08.19-.2.35-.34.48s-.31.23-.51.3c-.19.07-.4.11-.63.11-.11,0-.22-.01-.33-.04-.11-.03-.22-.06-.32-.11-.08.07-.14.14-.2.22-.05.08-.08.18-.08.3,0,.14.05.25.16.34s.31.13.61.13h.85c.51,0,.89.08,1.15.25s.38.43.38.8c0,.2-.05.4-.15.58-.1.18-.25.34-.44.48-.19.14-.42.25-.7.33-.27.08-.58.12-.92.12ZM43.06,364.04c.21,0,.4-.03.57-.08s.32-.12.44-.2.21-.17.28-.28.1-.22.1-.33c0-.2-.08-.34-.23-.42s-.37-.12-.66-.12h-.76c-.08,0-.18,0-.27-.01s-.2-.03-.29-.06c-.16.11-.27.23-.34.36-.07.13-.11.25-.11.38,0,.23.11.42.34.56.23.14.54.21.93.21ZM42.95,360.66c.13,0,.24-.02.36-.07.11-.05.21-.12.3-.21.09-.09.15-.2.2-.33.05-.13.07-.27.07-.44,0-.32-.09-.57-.27-.75-.18-.18-.4-.27-.66-.27s-.48.09-.66.27c-.18.18-.27.43-.27.75,0,.16.02.31.07.44s.12.24.2.33c.09.09.19.16.3.21.11.05.23.07.36.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M47.02,362.65c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM47.23,362.05c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M50.54,362.54v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.22-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M53.74,364.42c-.1,0-.2,0-.28-.02-.08-.01-.16-.04-.23-.07l.14-.58s.1.03.16.04c.06.01.12.02.17.02.25,0,.46-.09.62-.27.16-.18.28-.4.37-.67l.1-.32-1.75-4.38h.77l.89,2.42c.07.19.14.39.21.61.07.21.15.42.21.63h.04c.07-.2.13-.41.19-.62.06-.22.12-.42.18-.61l.78-2.42h.72l-1.65,4.73c-.08.22-.17.42-.26.6-.1.19-.21.35-.34.48-.13.14-.28.24-.45.32-.17.08-.36.12-.58.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M28.29,376.96c-.41,0-.8-.08-1.15-.23-.35-.16-.66-.37-.92-.64l.45-.52c.21.22.46.4.74.54.29.13.58.2.89.2.39,0,.69-.09.91-.27.22-.18.32-.41.32-.7,0-.15-.03-.28-.08-.38-.05-.11-.12-.2-.21-.27-.09-.07-.19-.14-.31-.2-.12-.06-.25-.12-.39-.19l-.85-.37c-.14-.06-.28-.13-.42-.22s-.27-.19-.39-.31c-.11-.12-.21-.26-.28-.43-.07-.17-.11-.36-.11-.57s.05-.43.14-.62c.09-.19.22-.36.39-.5.17-.14.36-.25.58-.33.23-.08.47-.12.74-.12.35,0,.68.07.98.2.3.13.55.31.77.53l-.41.49c-.18-.17-.38-.31-.6-.41-.22-.1-.47-.15-.74-.15-.33,0-.6.08-.8.23-.2.15-.3.36-.3.63,0,.14.03.27.09.36.06.1.13.19.23.26.1.08.2.14.31.2.11.06.23.11.35.16l.84.36c.17.07.33.15.48.25.15.09.28.2.39.32.11.12.19.27.26.43s.09.36.09.57c0,.23-.05.45-.14.66s-.23.38-.4.54c-.17.15-.38.27-.63.36-.25.09-.53.13-.84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M32.17,376.96c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25s.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M35.38,376.96c-.27,0-.53-.05-.77-.15-.24-.1-.46-.25-.64-.45-.19-.19-.33-.43-.45-.72-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72.19-.2.4-.35.64-.45.24-.1.5-.15.77-.15s.53.05.77.15c.24.1.46.25.64.45.19.2.33.44.45.72.11.28.17.61.17.98s-.06.68-.17.97c-.11.29-.26.53-.45.72-.19.2-.4.34-.64.45-.24.1-.5.15-.77.15ZM35.38,376.35c.19,0,.36-.04.51-.12.16-.08.29-.19.4-.34.11-.15.2-.32.26-.53s.09-.43.09-.68-.03-.48-.09-.69-.15-.38-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35-.11.15-.2.33-.26.54s-.09.44-.09.69.03.48.09.68.15.38.26.53c.11.15.24.26.4.34.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M39.5,376.85l-1.58-4.37h.77l.83,2.48c.07.22.13.43.2.65s.14.43.2.64h.04c.07-.21.13-.42.2-.64s.13-.43.2-.65l.83-2.48h.73l-1.55,4.37h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M43.77,376.96c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM43.98,376.36c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M47.29,376.85v-6.41h.73v4.34h.03l1.86-2.3h.82l-1.47,1.75,1.67,2.62h-.81l-1.28-2.11-.82.95v1.15h-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.13,371.58c-.14,0-.27-.04-.36-.13s-.15-.2-.15-.34c0-.14.05-.26.15-.35s.22-.13.36-.13.27.04.36.13.15.2.15.35-.05.25-.15.34-.22.13-.36.13ZM51.75,376.85v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.97,376.96c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.19,376.36c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M26.08,391.16v-5.9h1.68c.33,0,.63.03.9.09.27.06.51.16.7.29.19.13.34.31.45.54.11.22.16.49.16.82s-.05.58-.16.81c-.1.23-.25.42-.45.57-.19.15-.42.26-.69.34s-.56.11-.89.11h-.97v2.34h-.75ZM26.82,388.21h.88c.52,0,.9-.1,1.15-.29s.37-.5.37-.92-.13-.72-.39-.89c-.26-.16-.65-.25-1.17-.25h-.85v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M32.8,391.27c-.27,0-.53-.05-.77-.15-.24-.1-.46-.25-.64-.45s-.33-.43-.45-.72c-.11-.29-.17-.61-.17-.97s.06-.69.17-.98c.11-.29.26-.53.45-.72s.4-.35.64-.45c.24-.1.5-.15.77-.15s.53.05.77.15c.24.1.46.25.64.45s.33.44.45.72c.11.29.17.61.17.98s-.06.68-.17.97c-.11.29-.26.52-.45.72s-.4.34-.64.45c-.24.1-.5.15-.77.15ZM32.8,390.66c.19,0,.36-.04.51-.12.16-.08.29-.2.4-.34.11-.15.2-.32.26-.53.06-.2.09-.43.09-.68s-.03-.48-.09-.69-.15-.39-.26-.54c-.11-.15-.24-.27-.4-.35-.16-.08-.33-.12-.51-.12s-.36.04-.51.12c-.16.08-.29.2-.4.35-.11.15-.2.33-.26.54s-.09.44-.09.69.03.48.09.68c.06.2.15.38.26.53.11.15.24.26.4.34.16.08.33.12.51.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M35.97,391.16v-4.37h.61l.06.79h.03c.15-.28.33-.5.54-.66.21-.16.45-.24.7-.24.17,0,.33.03.47.09l-.14.65c-.07-.02-.14-.04-.2-.05-.06-.01-.14-.02-.23-.02-.19,0-.38.08-.58.22-.2.15-.38.41-.53.78v2.81h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.48,391.27c-.23,0-.43-.04-.59-.11-.16-.07-.29-.17-.39-.3-.1-.13-.17-.28-.21-.46s-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04.09-.02.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M43.42,391.27c-.47,0-.81-.14-1.02-.43-.21-.29-.32-.71-.32-1.28v-2.77h.75v2.67c0,.41.06.71.19.9.13.18.34.28.63.28.23,0,.43-.06.6-.18.17-.12.37-.3.58-.56v-3.11h.74v4.37h-.61l-.06-.68h-.03c-.2.24-.42.43-.64.58-.23.14-.49.22-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.51,393.18c-.27,0-.52-.03-.74-.08-.22-.05-.41-.13-.57-.23-.16-.1-.28-.22-.37-.37-.09-.14-.13-.31-.13-.5s.06-.36.17-.53c.11-.17.27-.32.47-.46v-.04c-.11-.07-.2-.16-.27-.27-.08-.12-.11-.26-.11-.44,0-.19.05-.35.15-.49s.21-.25.32-.32v-.04c-.14-.12-.27-.28-.39-.48-.12-.2-.18-.43-.18-.7,0-.24.04-.46.13-.65.09-.19.21-.36.36-.49.15-.13.33-.24.53-.31.2-.07.41-.11.63-.11.12,0,.23,0,.34.03s.2.05.28.08h1.52v.57h-.9c.1.1.19.23.26.39s.1.33.1.51c0,.23-.04.45-.13.63-.08.19-.2.35-.34.48s-.31.23-.51.3c-.19.07-.4.11-.63.11-.11,0-.22-.01-.33-.04-.11-.03-.22-.06-.32-.11-.08.07-.14.14-.2.22-.05.08-.08.18-.08.3,0,.14.05.25.16.34s.31.13.61.13h.85c.51,0,.89.08,1.15.25s.38.43.38.8c0,.2-.05.4-.15.58-.1.18-.25.34-.44.48-.19.14-.42.25-.7.33-.27.08-.58.12-.92.12ZM48.62,392.66c.21,0,.4-.03.57-.08s.32-.12.44-.2.21-.17.28-.28.1-.22.1-.33c0-.2-.08-.34-.23-.42s-.37-.12-.66-.12h-.76c-.08,0-.18,0-.27-.01s-.2-.03-.29-.06c-.16.11-.27.23-.34.36-.07.13-.11.25-.11.38,0,.23.11.42.34.56.23.14.54.21.93.21ZM48.51,389.28c.13,0,.24-.02.36-.07.11-.05.21-.12.3-.21.09-.09.15-.2.2-.33.05-.13.07-.27.07-.44,0-.32-.09-.57-.27-.75-.18-.18-.4-.27-.66-.27s-.48.09-.66.27c-.18.18-.27.43-.27.75,0,.16.02.31.07.44s.12.24.2.33c.09.09.19.16.3.21.11.05.23.07.36.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.58,391.27c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM52.8,390.68c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M56.89,391.27c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M38.77,405.58c-.41,0-.8-.08-1.15-.23-.35-.16-.66-.37-.92-.64l.45-.52c.21.22.46.4.74.54.29.13.58.2.89.2.39,0,.69-.09.91-.27.22-.18.32-.41.32-.7,0-.15-.03-.28-.08-.38-.05-.11-.12-.2-.21-.27-.09-.07-.19-.14-.31-.2-.12-.06-.25-.12-.39-.19l-.85-.37c-.14-.06-.28-.13-.42-.22s-.27-.19-.39-.31c-.11-.12-.21-.26-.28-.43-.07-.17-.11-.36-.11-.57s.05-.43.14-.62c.09-.19.22-.36.39-.5.17-.14.36-.25.58-.33.23-.08.47-.12.74-.12.35,0,.68.07.98.2.3.13.55.31.77.53l-.41.49c-.18-.17-.38-.31-.6-.41-.22-.1-.47-.15-.74-.15-.33,0-.6.08-.8.23-.2.15-.3.36-.3.63,0,.14.03.27.09.36.06.1.13.19.23.26.1.08.2.14.31.2.11.06.23.11.35.16l.84.36c.17.07.33.15.48.25.15.09.28.2.39.32.11.12.19.27.26.43s.09.36.09.57c0,.23-.05.45-.14.66s-.23.38-.4.54c-.17.15-.38.27-.63.36-.25.09-.53.13-.84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M41.87,407.32v-6.22h.61l.06.5h.03c.2-.17.42-.31.65-.43.24-.12.48-.18.74-.18.28,0,.53.05.75.16.22.11.4.26.54.45.14.2.25.43.33.7.07.27.11.58.11.92,0,.37-.05.7-.15.99-.1.29-.24.54-.41.74-.17.2-.38.36-.6.46s-.47.16-.72.16c-.2,0-.41-.04-.61-.13s-.4-.21-.61-.37l.02.77v1.48h-.74ZM43.68,404.96c.18,0,.35-.04.5-.12.15-.08.29-.2.4-.34.11-.15.2-.33.26-.54s.09-.46.09-.73c0-.24-.02-.46-.06-.66s-.11-.37-.2-.51c-.09-.14-.21-.25-.36-.33s-.32-.12-.53-.12c-.19,0-.37.05-.56.15-.19.1-.39.25-.61.44v2.29c.2.17.39.29.58.36.19.07.35.1.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M47.87,405.58c-.37,0-.67-.11-.91-.32-.24-.22-.36-.52-.36-.92,0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.4-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM48.09,404.99c.21,0,.41-.05.59-.15.19-.1.38-.24.59-.44v-1.21c-.37.05-.67.1-.92.17s-.45.14-.6.23c-.15.09-.26.19-.33.31-.07.12-.1.24-.1.38,0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M51.78,400.2c-.14,0-.27-.04-.36-.13s-.15-.2-.15-.34c0-.14.05-.26.15-.35s.22-.13.36-.13.27.04.36.13.15.2.15.35-.05.25-.15.34-.22.13-.36.13ZM51.4,405.47v-4.37h.74v4.37h-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M53.61,405.47v-4.37h.61l.06.63h.03c.21-.21.43-.39.66-.53.23-.14.5-.21.81-.21.46,0,.8.14,1.01.43.21.29.32.71.32,1.28v2.77h-.74v-2.67c0-.41-.07-.71-.2-.9-.13-.18-.34-.27-.63-.27-.23,0-.43.06-.6.17-.17.11-.37.28-.59.5v3.17h-.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-333"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M37.59,419.78v-5.9h.9l1.13,3.15c.07.2.14.41.21.62.07.21.14.41.21.62h.04c.07-.2.14-.41.2-.62s.13-.41.2-.62l1.12-3.15h.91v5.9h-.7v-3.25c0-.26.01-.55.04-.87.02-.32.04-.61.06-.87h-.04l-.47,1.34-1.12,3.06h-.49l-1.12-3.06-.47-1.34h-.04c.02.26.04.56.06.87.02.32.03.61.03.87v3.25h-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M45.07,419.89c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM45.29,419.3c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M49.38,419.89c-.28,0-.48-.08-.6-.25s-.18-.41-.18-.74v-5.53h.74v5.58c0,.12.02.2.06.25.04.05.09.07.14.07h.07s.05,0,.09-.02l.1.56s-.1.04-.17.05c-.07.01-.15.02-.25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M52.27,419.89c-.23,0-.43-.04-.59-.11-.16-.07-.29-.17-.39-.3-.1-.13-.17-.28-.21-.46s-.06-.38-.06-.59v-2.42h-.65v-.56l.68-.04.09-1.22h.62v1.22h1.18v.6h-1.18v2.43c0,.27.05.48.15.63.1.15.27.22.53.22.08,0,.16-.01.25-.04.09-.02.17-.05.24-.08l.14.56c-.12.04-.25.08-.39.11-.14.03-.28.05-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M54.95,419.89c-.37,0-.67-.11-.91-.32s-.36-.52-.36-.92c0-.48.21-.85.64-1.1.43-.25,1.11-.43,2.04-.54,0-.14-.01-.27-.04-.41-.03-.13-.07-.25-.14-.35-.07-.1-.16-.18-.27-.25-.12-.06-.27-.09-.45-.09-.25,0-.49.05-.71.14-.22.1-.42.2-.59.32l-.29-.51c.2-.13.45-.26.75-.38s.62-.18.97-.18c.53,0,.92.16,1.16.49.24.33.36.76.36,1.31v2.68h-.61l-.06-.52h-.03c-.21.17-.44.32-.67.45-.24.12-.5.18-.77.18ZM55.16,419.3c.21,0,.41-.05.59-.15.19-.1.38-.25.59-.44v-1.22c-.37.05-.67.11-.92.17-.25.07-.45.14-.6.23s-.26.19-.33.31-.1.24-.1.38c0,.25.08.43.23.54.15.11.33.16.55.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M70.2,33.39v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.65,33.39v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64s-.34-.22-.59-.22c-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.76,35.13l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.14,33.49c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5.13.41.13.64c0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM84.17,32.58c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM84.5,30.06c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-306"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.22,31.14c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,30.4c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,33.49l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,33.49c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.55,32.76c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M70.2,47.7v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.7,47.81c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM76.7,46.78c.11,0,.22-.03.31-.09s.18-.16.25-.31c.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.76,49.44l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.42,47.7v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM83.21,45.32h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.22,45.45c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,44.71c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,47.81l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,47.81c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.55,47.07c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.38,62.12c-.38,0-.71-.07-.99-.21-.28-.14-.51-.3-.69-.48l.7-.79c.1.11.23.2.39.28s.33.12.5.12.31-.03.45-.09c.14-.06.26-.16.36-.3s.19-.32.25-.55c.06-.23.1-.51.11-.84-.07.1-.16.18-.25.26-.1.07-.19.14-.3.19-.1.05-.2.09-.31.12-.1.03-.2.04-.29.04-.25,0-.47-.04-.68-.11s-.39-.18-.54-.32c-.15-.14-.27-.33-.36-.55-.09-.22-.13-.48-.13-.78s.05-.56.15-.8c.1-.24.24-.44.41-.61.17-.17.37-.3.6-.38.23-.09.48-.13.73-.13.28,0,.54.05.81.16.26.11.49.28.69.5.2.23.36.52.49.88s.18.79.18,1.29c0,.53-.06,1-.19,1.39-.13.39-.3.71-.51.96s-.46.44-.74.56c-.28.12-.57.18-.87.18ZM76.59,58.93c.15,0,.3-.04.45-.13.15-.09.29-.23.4-.44-.06-.45-.17-.76-.34-.93-.17-.17-.35-.26-.55-.26-.19,0-.36.07-.5.22s-.22.38-.22.71c0,.31.07.52.22.64.14.12.32.18.54.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,63.75l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.96,62.12c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16s.18-.15.23-.24c.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,59.76c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,59.02c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,62.12l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,62.12c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,61.38c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.69,76.43c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5.13.41.13.64c0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM76.71,75.51c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM77.05,72.99c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,78.07l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.3,76.43c-.28,0-.54-.05-.81-.16-.26-.11-.49-.28-.69-.5-.2-.23-.36-.52-.48-.88s-.18-.79-.18-1.29c0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96.21-.25.46-.44.74-.56.28-.12.57-.18.87-.18.38,0,.7.07.98.2.28.14.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28-.16-.08-.33-.12-.49-.12-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3s-.19.33-.26.55c-.07.23-.1.51-.12.84.07-.1.16-.18.25-.26.1-.07.19-.14.3-.19.1-.05.2-.09.31-.12.1-.03.2-.04.29-.04.25,0,.47.04.68.11.21.07.39.18.54.32.15.14.27.33.36.55.08.22.13.48.13.78s-.05.57-.15.8c-.1.23-.24.44-.41.6-.17.17-.37.3-.6.38-.23.09-.48.13-.73.13ZM84.27,75.44c.2,0,.37-.07.51-.22.14-.15.21-.38.21-.71,0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.45.13s-.29.23-.41.44c.03.23.08.42.14.57.06.15.13.27.21.36.08.09.16.16.26.2.09.04.19.06.29.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,74.07c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,73.33c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,76.43l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,76.43c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,75.69c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.69,90.74c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85s.42-.41.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.32.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5c.08.2.13.41.13.64,0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58.19.23.29.54.29.92,0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM76.71,89.82c.22,0,.4-.06.55-.18s.22-.29.22-.54c0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21s-.31-.14-.49-.22c-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59.17.14.38.21.62.21ZM77.05,87.3c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54s-.29-.2-.51-.2c-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,92.38l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.99,90.74c-.47,0-.86-.08-1.19-.23-.32-.15-.6-.34-.83-.57l.59-.84c.17.16.36.29.56.4.2.11.42.17.67.17.29,0,.53-.08.7-.22.17-.15.26-.37.26-.67s-.08-.51-.25-.66-.38-.22-.65-.22c-.08,0-.16,0-.23.01-.07,0-.13.03-.19.05-.06.02-.13.05-.2.09s-.15.08-.23.13l-.59-.38.16-2.89h3.24v1.12h-2.1l-.1,1.07c.11-.05.21-.08.31-.1.1-.02.21-.03.33-.03.25,0,.48.04.7.11.22.07.41.18.58.32.17.14.3.33.4.55.1.22.14.49.14.79s-.06.6-.17.85-.27.46-.46.63-.42.3-.67.39c-.25.09-.52.13-.8.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-312"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,88.38c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,87.64c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,90.74l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,90.74c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.54,90c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-259"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.69,105.05c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5.13.41.13.64c0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM76.71,104.13c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM77.05,101.61c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,106.69l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.96,105.05c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16s.18-.15.23-.24c.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,102.69c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,101.95c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,105.05l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,105.05c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,104.31c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.69,119.36c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5.13.41.13.64c0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM76.71,118.44c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM77.05,115.92c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,121l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M82.1,119.25v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64s-.34-.22-.59-.22c-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,117c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,116.26c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,119.36l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,119.36c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,118.62c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.85,133.67c-.28,0-.54-.05-.81-.16-.26-.11-.49-.28-.69-.5-.2-.23-.36-.52-.48-.88s-.18-.79-.18-1.29c0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96.21-.25.46-.44.74-.56.28-.12.57-.18.87-.18.38,0,.7.07.98.2.28.14.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28-.16-.08-.33-.12-.49-.12-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3s-.19.33-.26.55c-.07.23-.1.51-.12.84.07-.1.16-.18.25-.26.1-.07.19-.14.3-.19.1-.05.2-.09.31-.12.1-.03.2-.04.29-.04.25,0,.47.04.68.11.21.07.39.18.54.32.15.14.27.33.36.55.08.22.13.48.13.78s-.05.57-.15.8c-.1.23-.24.44-.41.6-.17.17-.37.3-.6.38-.23.09-.48.13-.73.13ZM76.82,132.68c.2,0,.37-.07.51-.22.14-.15.21-.38.21-.71,0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.45.13s-.29.23-.41.44c.03.23.08.42.14.57.06.15.13.27.21.36.08.09.16.16.26.2.09.04.19.06.29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,135.31l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M82.1,133.56v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64s-.34-.22-.59-.22c-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,131.31c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,130.58c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,133.67l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,133.67c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,132.93c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.85,147.98c-.28,0-.54-.05-.81-.16-.26-.11-.49-.28-.69-.5-.2-.23-.36-.52-.48-.88s-.18-.79-.18-1.29c0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96.21-.25.46-.44.74-.56.28-.12.57-.18.87-.18.38,0,.7.07.98.2.28.14.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28-.16-.08-.33-.12-.49-.12-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3s-.19.33-.26.55c-.07.23-.1.51-.12.84.07-.1.16-.18.25-.26.1-.07.19-.14.3-.19.1-.05.2-.09.31-.12.1-.03.2-.04.29-.04.25,0,.47.04.68.11.21.07.39.18.54.32.15.14.27.33.36.55.08.22.13.48.13.78s-.05.57-.15.8c-.1.23-.24.44-.41.6-.17.17-.37.3-.6.38-.23.09-.48.13-.73.13ZM76.82,146.99c.2,0,.37-.07.51-.22.14-.15.21-.38.21-.71,0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.45.13s-.29.23-.41.44c.03.23.08.42.14.57.06.15.13.27.21.36.08.09.16.16.26.2.09.04.19.06.29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,149.62l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.15,147.98c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM84.15,146.96c.11,0,.22-.03.31-.09s.18-.16.25-.31c.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-349"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,145.62c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,144.89c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,147.98l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,147.98c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,147.24c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.54,162.29c-.47,0-.86-.08-1.19-.23-.32-.15-.6-.34-.83-.57l.59-.84c.17.16.36.29.56.4.2.11.42.17.67.17.29,0,.53-.08.7-.23.17-.15.26-.37.26-.67s-.08-.51-.25-.66c-.17-.15-.38-.22-.65-.22-.08,0-.16,0-.23.01-.07,0-.13.03-.19.05s-.13.05-.2.09-.15.08-.23.13l-.59-.38.16-2.89h3.24v1.12h-2.1l-.1,1.07c.11-.05.21-.08.31-.1.1-.02.21-.03.33-.03.25,0,.48.04.7.11.22.07.41.18.58.32s.3.33.4.55c.1.22.14.49.14.79s-.06.6-.17.85-.27.45-.46.63-.42.3-.67.39c-.25.09-.52.13-.8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,163.93l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.14,162.29c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5.13.41.13.64c0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM84.16,161.38c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM84.5,158.85c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,159.94c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,159.2c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,162.29l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,162.29c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,161.56c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.54,176.6c-.47,0-.86-.08-1.19-.23-.32-.15-.6-.34-.83-.57l.59-.84c.17.16.36.29.56.4.2.11.42.17.67.17.29,0,.53-.08.7-.23.17-.15.26-.37.26-.67s-.08-.51-.25-.66c-.17-.15-.38-.22-.65-.22-.08,0-.16,0-.23.01-.07,0-.13.03-.19.05s-.13.05-.2.09-.15.08-.23.13l-.59-.38.16-2.89h3.24v1.12h-2.1l-.1,1.07c.11-.05.21-.08.31-.1.1-.02.21-.03.33-.03.25,0,.48.04.7.11.22.07.41.18.58.32s.3.33.4.55c.1.22.14.49.14.79s-.06.6-.17.85-.27.45-.46.63-.42.3-.67.39c-.25.09-.52.13-.8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,178.24l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.3,176.6c-.28,0-.54-.05-.81-.16-.26-.11-.49-.28-.69-.5-.2-.23-.36-.52-.48-.88s-.18-.79-.18-1.29c0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96.21-.25.46-.44.74-.56.28-.12.57-.18.87-.18.38,0,.7.07.98.2.28.14.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28-.16-.08-.33-.12-.49-.12-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3s-.19.33-.26.55c-.07.23-.1.51-.12.84.07-.1.16-.18.25-.26.1-.07.19-.14.3-.19.1-.05.2-.09.31-.12.1-.03.2-.04.29-.04.25,0,.47.04.68.11.21.07.39.18.54.32.15.14.27.33.36.55.08.22.13.48.13.78s-.05.57-.15.8c-.1.23-.24.44-.41.6-.17.17-.37.3-.6.38-.23.09-.48.13-.73.13ZM84.27,175.61c.2,0,.37-.07.51-.22.14-.15.21-.38.21-.71,0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.45.13s-.29.23-.41.44c.03.23.08.42.14.57.06.15.13.27.21.36.08.09.16.16.26.2.09.04.19.06.29.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-297"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,174.25c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,173.51c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,176.6l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,176.6c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,175.87c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-334"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.96,190.81v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM75.76,188.43h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,192.55l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.14,190.92c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5.13.41.13.64c0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM84.16,190c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM84.5,187.48c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,188.56c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,187.82c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,190.92l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,190.92c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,190.18c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.96,205.12v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM75.76,202.74h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,206.86l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.2,205.12c.02-.47.07-.91.13-1.31s.15-.78.27-1.14c.12-.36.27-.72.45-1.07.18-.35.41-.71.68-1.08h-2.56v-1.12h3.98v.81c-.33.4-.6.78-.8,1.13-.2.35-.36.71-.47,1.09s-.19.78-.24,1.21c-.05.43-.08.92-.11,1.48h-1.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,202.87c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,202.13c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,205.23l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,205.23c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,204.49c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-348"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M76.96,219.43v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM75.76,217.05h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M79.75,221.18l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M83.96,219.54c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16s.18-.15.23-.24c.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M88.21,217.18c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,216.44c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,219.54l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,219.54c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,218.8c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-345"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.96,233.74v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM75.76,231.36h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.32-.23.48s-.16.32-.24.49l-.76,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,235.49l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M82.1,233.74v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73s.18-.44.18-.64c0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,231.49c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,230.75c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,233.85l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,233.85c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.54,233.11c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.51,248.16c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.23-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.13s-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,249.8l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.42,248.05v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM83.21,245.68h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.46.04-.63h-.04c-.07.16-.15.31-.23.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,245.8c-.21,0-.4-.04-.58-.12s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.37.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.12-.58.12ZM88.21,245.06c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,248.16l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,248.16c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.12.58-.12s.4.04.58.12c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.54,247.42c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.65,262.36v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73s.18-.44.18-.64c0-.28-.07-.5-.22-.64s-.34-.22-.59-.22c-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.04.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,264.11l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.99,262.47c-.47,0-.86-.08-1.19-.23-.32-.15-.6-.34-.83-.57l.59-.84c.17.16.36.29.56.4.2.11.42.17.67.17.29,0,.53-.08.7-.23.17-.15.26-.37.26-.67s-.08-.51-.25-.66-.38-.22-.65-.22c-.08,0-.16,0-.23.01-.07,0-.13.03-.19.05s-.13.05-.2.09-.15.08-.23.13l-.59-.38.16-2.89h3.24v1.12h-2.1l-.1,1.07c.11-.05.21-.08.31-.1.1-.02.21-.03.33-.03.25,0,.48.04.7.11.22.07.41.18.58.32.17.14.3.33.4.55.1.22.14.49.14.79s-.06.6-.17.85-.27.46-.46.62c-.19.17-.42.3-.67.39-.25.09-.52.13-.8.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,260.11c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.12.58-.12.41.04.58.12c.18.08.33.21.46.37.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,259.38c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,262.47l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,262.47c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,261.73c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-338"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.95,276.67v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.3h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,278.42l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M84.14,276.78c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.5-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85s.42-.41.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.2.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31.27.3.35.5c.08.19.13.41.13.64,0,.28-.08.52-.23.73s-.32.38-.52.52v.04c.28.15.51.34.7.58s.29.54.29.92c0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM84.16,275.86c.22,0,.4-.06.55-.18s.22-.29.22-.54c0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21s-.31-.14-.49-.22c-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59.17.14.38.21.62.21ZM84.5,273.34c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54s-.29-.2-.51-.2c-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5s.09.42.27.55c.18.13.42.25.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,274.42c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,273.69c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25ZM88.41,276.78l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,276.78c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.4.04.58.13.33.21.46.36.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,276.04c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.95,290.98v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,292.73l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.96,291.09c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18s.25-.28.25-.5c0-.13-.02-.24-.07-.34-.04-.1-.12-.19-.24-.26-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.23-.24s.07-.2.07-.31c0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.13s-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32s-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,288.73c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.37.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,288c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25ZM88.41,291.09l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,291.09c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.4.04.58.13.33.21.46.36.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,290.35c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-322"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.95,305.29v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,307.04l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.96,305.4c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34-.04-.1-.12-.19-.24-.26-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.23-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.04.81.1.24.07.45.17.62.31s.3.3.4.49.14.41.14.67c0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,303.04c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,302.31c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,305.4l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,305.4c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.54,304.67c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.95,319.61v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,321.35l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.96,319.71c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18s.25-.28.25-.5c0-.13-.02-.24-.07-.34-.04-.1-.12-.19-.24-.26-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.23-.24s.07-.2.07-.31c0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.13s-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32s-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,317.36c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.37.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,316.62c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25ZM88.41,319.71l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,319.71c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.4.04.58.13.33.21.46.36.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,318.98c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-341"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M74.95,333.92v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,335.66l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M82.1,333.92v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73s.18-.44.18-.64c0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,331.67c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,330.93c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,334.03l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,334.03c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.54,333.29c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.69,348.34c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28.24-.67.41-.92c.18-.25.39-.43.64-.56s.53-.18.84-.18.58.06.84.18.47.31.64.56.31.56.41.92.15.79.15,1.28-.05.92-.15,1.29-.24.68-.41.94-.39.44-.64.57-.53.19-.84.19ZM76.69,347.31c.11,0,.22-.03.31-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M79.75,349.97l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M83.96,348.34c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18s.25-.28.25-.5c0-.13-.02-.24-.07-.34-.04-.1-.12-.19-.24-.26-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.23-.24s.07-.2.07-.31c0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.13s-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32s-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M88.21,345.98c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.37.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.21,345.24c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25ZM88.41,348.34l3.17-6.08h.77l-3.17,6.08h-.76ZM92.54,348.34c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.4.04.58.13.33.21.46.36.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.54,347.6c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M69.87,360.04v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M76.7,362.65c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29-.24.68-.41.94c-.18.25-.39.44-.64.57s-.53.19-.84.19ZM76.7,361.62c.11,0,.22-.03.31-.08.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29s-.2-.08-.31-.08c-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.08.31.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M79.76,364.29l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M83.2,362.54c.02-.47.07-.91.13-1.31.06-.4.15-.78.27-1.14s.27-.72.45-1.07c.18-.35.41-.71.68-1.08h-2.56v-1.12h3.98v.81c-.33.4-.6.78-.8,1.13-.2.35-.36.71-.47,1.09s-.19.78-.24,1.21c-.05.43-.08.92-.11,1.48h-1.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M88.22,360.29c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,359.55c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,362.65l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,362.65c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.55,361.91c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M69.87,374.35v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M76.7,376.96c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28.24-.67.41-.92c.18-.25.39-.43.64-.56s.53-.18.84-.18.58.06.84.18.47.31.64.56.31.56.41.92.15.79.15,1.28-.05.92-.15,1.29-.24.68-.41.94-.39.44-.64.57-.53.19-.84.19ZM76.7,375.93c.11,0,.22-.03.31-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M79.76,378.6l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M84.14,376.96c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32s-.31-.3-.41-.5c-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.86.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.2.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.32.27.3.35.5c.08.19.13.41.13.64,0,.28-.08.52-.23.73s-.32.39-.52.52v.04c.28.15.51.34.7.58.19.23.29.54.29.92,0,.23-.05.44-.14.63s-.23.36-.41.5c-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM84.17,376.04c.22,0,.4-.06.55-.17.14-.12.22-.3.22-.54,0-.13-.03-.23-.09-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59.17.14.38.21.62.21ZM84.5,373.52c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16s-.19.27-.19.5c0,.23.09.42.27.55.18.13.42.25.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-342"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M88.22,374.6c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.37.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,373.86c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25ZM88.41,376.96l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,376.96c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.4.04.58.13.33.21.46.36.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.55,376.22c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-331"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M69.87,388.66v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M74.95,391.16v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M79.76,392.91l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M82.4,391.16v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M88.22,388.91c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,388.17c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,391.27l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,391.27c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.55,390.53c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-352"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M69.87,402.97v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M74.65,405.47v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68s.65-.23,1.05-.23c.28,0,.54.04.77.13s.43.21.6.37c.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73s-.24.5-.41.75c-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.04.48-.05s.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M79.76,407.22l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M84.15,405.58c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94s-.15-.8-.15-1.29.05-.91.15-1.28.24-.67.41-.92c.18-.25.39-.43.64-.56s.53-.18.84-.18.58.06.84.18.47.31.64.56.31.56.41.92.15.79.15,1.28-.05.92-.15,1.29-.24.68-.41.94-.39.44-.64.57-.53.19-.84.19ZM84.15,404.55c.11,0,.22-.03.31-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-272"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M88.22,403.22c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37s.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.37.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,402.48c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25ZM88.41,405.58l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,405.58c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36s.38-.13.58-.13.4.04.58.13.33.21.46.36.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM92.55,404.84c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M69.87,417.28v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M76.97,419.78v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM75.76,417.41h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.32-.23.48s-.16.32-.24.49l-.76,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M79.76,421.53l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M84.3,419.89c-.28,0-.54-.05-.81-.16-.26-.11-.49-.28-.69-.5-.2-.23-.36-.52-.48-.88-.12-.36-.18-.79-.18-1.29,0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96.21-.25.46-.44.74-.56.28-.12.57-.18.87-.18.38,0,.7.07.98.2.28.13.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28-.16-.08-.33-.12-.49-.12-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3-.1.14-.19.33-.26.55-.07.23-.1.51-.12.84.07-.1.16-.18.25-.26.1-.07.19-.14.3-.19s.2-.09.31-.12.2-.04.29-.04c.25,0,.47.04.68.11.21.07.39.18.54.32.15.14.27.33.36.55s.13.48.13.78-.05.57-.15.8-.24.44-.41.6c-.17.17-.37.29-.6.38-.23.09-.48.13-.73.13ZM84.27,418.9c.2,0,.37-.07.51-.22.14-.15.21-.38.21-.71,0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.45.13s-.29.23-.41.44c.03.23.08.42.14.57.06.15.13.27.21.36.08.09.16.16.26.2.09.04.19.06.29.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M88.22,417.53c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36.38-.13.58-.13.41.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM88.22,416.8c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88c.1.17.23.25.38.25ZM88.41,419.89l3.17-6.08h.77l-3.17,6.08h-.76ZM92.55,419.89c-.21,0-.4-.04-.58-.13s-.33-.21-.46-.37c-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37-.38.13-.58.13ZM92.55,419.15c.15,0,.28-.08.38-.25s.16-.46.16-.88-.05-.71-.16-.87-.23-.24-.38-.24-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.1.17.23.25.38.25Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Element_1_copy2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 30.39,
    x2: 456.32,
    y2: 30.39
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 44.7,
    x2: 456.32,
    y2: 44.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 59.01,
    x2: 456.32,
    y2: 59.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 73.32,
    x2: 456.32,
    y2: 73.32
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 87.63,
    x2: 456.32,
    y2: 87.63
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-311"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 101.94,
    x2: 456.32,
    y2: 101.94
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 116.25,
    x2: 456.32,
    y2: 116.25
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 130.56,
    x2: 456.32,
    y2: 130.56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 144.87,
    x2: 456.32,
    y2: 144.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 159.19,
    x2: 456.32,
    y2: 159.19
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 173.5,
    x2: 456.32,
    y2: 173.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 187.81,
    x2: 456.32,
    y2: 187.81
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 202.12,
    x2: 456.32,
    y2: 202.12
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 216.43,
    x2: 456.32,
    y2: 216.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-243"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 230.74,
    x2: 456.32,
    y2: 230.74
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 245.05,
    x2: 456.32,
    y2: 245.05
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 259.36,
    x2: 456.32,
    y2: 259.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-261"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 273.67,
    x2: 456.32,
    y2: 273.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 287.98,
    x2: 456.32,
    y2: 287.98
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 302.3,
    x2: 456.32,
    y2: 302.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 316.61,
    x2: 456.32,
    y2: 316.61
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 330.92,
    x2: 456.32,
    y2: 330.92
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-254"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 345.23,
    x2: 456.32,
    y2: 345.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 359.54,
    x2: 456.32,
    y2: 359.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 373.85,
    x2: 456.32,
    y2: 373.85
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-244"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 388.16,
    x2: 456.32,
    y2: 388.16
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 402.47,
    x2: 456.32,
    y2: 402.47
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-118",
    x1: 314.03,
    y1: 416.78,
    x2: 456.32,
    y2: 416.78
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 385.18,
    y1: 26.81,
    x2: 385.18,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 314.03,
    y1: 26.81,
    x2: 314.03,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 456.32,
    y1: 26.81,
    x2: 456.32,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 352.45,
    y: 29.67,
    width: 32.73,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 43.98,
    width: 15.65,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 362.41,
    y: 58.29,
    width: 22.77,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 368.1,
    y: 72.6,
    width: 17.07,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 366.68,
    y: 86.91,
    width: 18.5,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-255"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 358.14,
    y: 115.54,
    width: 27.03,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 129.85,
    width: 32.73,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-293"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 351.03,
    y: 144.16,
    width: 34.15,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 373.79,
    y: 158.47,
    width: 11.38,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-351"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 356.72,
    y: 172.78,
    width: 28.46,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 382.33,
    y: 187.09,
    width: 2.85,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-317"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 382.33,
    y: 201.4,
    width: 2.85,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 370.95,
    y: 215.71,
    width: 14.23,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-324"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 360.99,
    y: 230.02,
    width: 24.19,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 353.87,
    y: 244.34,
    width: 31.3,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 368.1,
    y: 258.65,
    width: 17.07,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 370.95,
    y: 272.96,
    width: 14.23,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 373.79,
    y: 287.27,
    width: 11.38,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 342.49,
    y: 301.58,
    width: 42.69,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 315.89,
    width: 2.85,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 330.2,
    width: 17.07,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 344.51,
    width: 14.23,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-335"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 365.26,
    y: 358.82,
    width: 19.92,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 382.33,
    y: 373.13,
    width: 2.85,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 387.45,
    width: 14.23,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 401.76,
    width: 2.85,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 385.18,
    y: 416.07,
    width: 35.57,
    height: 1.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 352.45,
    cy: 30.39,
    r: 2.83,
    transform: "translate(241.9 366.43) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 400.83,
    cy: 44.7,
    r: 2.83,
    transform: "translate(265.23 424.53) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 362.41,
    cy: 59.01,
    r: 2.83,
    transform: "translate(221.72 398.17) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 368.1,
    cy: 73.32,
    r: 2.83,
    transform: "translate(212.17 414.73) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-321"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 366.68,
    cy: 87.63,
    r: 2.83,
    transform: "translate(197.15 424.37) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 385.18,
    cy: 101.94,
    r: 2.83,
    transform: "translate(197.47 453.39) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 358.14,
    cy: 116.25,
    r: 2.83,
    transform: "translate(162.72 438.1) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 417.9,
    cy: 130.56,
    r: 2.83,
    transform: "translate(210.67 516.23) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-240"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 351.03,
    cy: 144.87,
    r: 2.83,
    transform: "translate(129.38 453.23) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 373.79,
    cy: 159.19,
    r: 2.83,
    transform: "translate(132.99 486.41) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-323"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 356.72,
    cy: 173.5,
    r: 2.83,
    transform: "translate(105.91 480.81) rotate(-76.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 382.33,
    cy: 187.81,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 382.33,
    cy: 202.12,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-248",
    cx: 370.95,
    cy: 216.43,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 360.99,
    cy: 230.74,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 353.87,
    cy: 245.05,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 368.1,
    cy: 259.36,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-274"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 370.95,
    cy: 273.67,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 373.79,
    cy: 287.98,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 342.49,
    cy: 302.3,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 388.02,
    cy: 316.61,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 402.25,
    cy: 330.92,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 399.4,
    cy: 345.23,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 365.26,
    cy: 359.54,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 382.33,
    cy: 373.85,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 399.4,
    cy: 388.16,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 388.02,
    cy: 402.47,
    r: 2.83
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-344"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 420.75,
    cy: 416.78,
    r: 2.83,
    transform: "translate(-12.06 12.54) rotate(-1.68)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-350"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 314.03,
    y1: 420.36,
    x2: 314.03,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M288.14,434.71h4.3v.49h-4.3v-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M293.7,436.21s.44.7,1.35.7c.83,0,1.49-.59,1.49-1.4s-.66-1.4-1.51-1.4c-.64,0-1.09.32-1.09.32l-.37-.13.32-2.9h2.89v.53h-2.38l-.17,1.53c-.03.21-.06.34-.06.34h.02s.37-.23.91-.23c1.2,0,2.06.87,2.06,1.95s-.91,1.96-2.07,1.96-1.75-.85-1.75-.85l.37-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M298.4,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M300.28,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM303.79,434.38c0-1.42-.31-2.53-1.45-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.45-1.11,1.45-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M305.47,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM310.08,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM307.36,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM309.53,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM309.53,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 385.18,
    y1: 420.36,
    x2: 385.18,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M364.03,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM367.54,434.38c0-1.42-.31-2.53-1.45-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.45-1.11,1.45-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M369.54,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M371.42,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM374.93,434.38c0-1.42-.31-2.53-1.44-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.44-1.11,1.44-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-340"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M376.61,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM381.22,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM378.5,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM380.67,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM380.67,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-117",
    x1: 456.32,
    y1: 420.36,
    x2: 456.32,
    y2: 437.37
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M435.98,436.21s.44.7,1.35.7c.83,0,1.49-.59,1.49-1.4s-.66-1.4-1.51-1.4c-.64,0-1.09.32-1.09.32l-.37-.13.32-2.9h2.89v.53h-2.38l-.17,1.53c-.03.21-.06.34-.06.34h.02s.37-.23.91-.23c1.2,0,2.06.87,2.06,1.95s-.91,1.96-2.07,1.96-1.75-.85-1.75-.85l.37-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M440.68,436.67h.64l-.63,1.52h-.49l.48-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M442.56,434.38c0-1.72.51-3.08,2.07-3.08s2.06,1.37,2.06,3.08-.5,3.09-2.06,3.09-2.07-1.36-2.07-3.09ZM446.07,434.38c0-1.42-.31-2.53-1.45-2.53s-1.45,1.11-1.45,2.53.31,2.54,1.45,2.54,1.45-1.11,1.45-2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M447.76,432.47c0-.65.53-1.18,1.19-1.18s1.2.54,1.2,1.18-.54,1.18-1.2,1.18-1.19-.53-1.19-1.18ZM452.36,431.39h.6l-4.55,5.97h-.61l4.56-5.97ZM449.64,432.47c0-.38-.31-.71-.7-.71s-.69.32-.69.71.3.71.69.71.7-.31.7-.71ZM451.82,435.11c.66,0,1.2.54,1.2,1.19s-.54,1.17-1.2,1.17-1.19-.53-1.19-1.17.53-1.19,1.19-1.19ZM451.82,437c.39,0,.7-.31.7-.71s-.31-.71-.7-.71-.68.32-.68.71.29.71.68.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-115",
    x1: 385.18,
    y1: 26.81,
    x2: 385.18,
    y2: 420.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-309"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,30.88v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.49,33.39v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,35.13l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.8,33.49c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26c-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.22-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.81.1.24.07.45.17.62.31.17.14.3.3.4.49s.14.41.14.67c0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.82.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,31.14c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,30.4c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,33.49l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,33.49c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,32.76c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M288.79,47.7v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,49.44l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M296.24,47.7v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,45.45c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,44.71c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,47.81l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,47.81c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,47.07c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,59.51v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,62.01v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,63.75l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M298.14,62.12c-.28,0-.54-.05-.81-.16-.26-.11-.49-.28-.69-.5-.2-.23-.36-.52-.48-.88s-.18-.79-.18-1.29c0-.53.06-1,.19-1.39.13-.39.3-.71.51-.96.21-.25.46-.44.74-.56.28-.12.57-.18.87-.18.38,0,.7.07.98.2.28.14.5.3.68.48l-.69.79c-.1-.11-.23-.2-.4-.28-.16-.08-.33-.12-.49-.12-.16,0-.3.03-.44.09-.14.06-.26.16-.36.3-.11.14-.19.33-.26.55s-.1.51-.12.84c.07-.1.16-.18.25-.26.1-.07.2-.14.3-.19.1-.05.2-.09.31-.12.1-.03.2-.04.29-.04.25,0,.47.04.68.11.21.07.39.18.54.32.15.14.27.33.36.55.08.22.13.48.13.78s-.05.57-.15.8c-.1.23-.24.44-.41.6-.17.17-.37.3-.6.38-.23.09-.48.13-.73.13ZM298.11,61.13c.2,0,.37-.07.51-.22s.21-.38.21-.71c0-.31-.07-.52-.21-.64-.14-.12-.32-.18-.54-.18-.15,0-.3.04-.46.13-.15.09-.29.23-.41.44.03.23.08.42.13.57s.13.27.21.36c.08.09.16.16.26.2.09.04.19.06.29.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,59.76c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,59.02c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,62.12l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,62.12c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,61.38c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,73.82v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,76.32v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,78.07l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M295.94,76.32v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,74.07c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,73.33c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,76.43l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,76.43c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,75.69c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,88.13v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,90.63v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,92.38l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.8,90.74c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34-.04-.1-.12-.19-.24-.26-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.22-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46s-.29-.17-.52-.17c-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.04.81.1.24.07.45.17.62.31s.3.3.4.49c.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.82.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,88.38c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,87.64c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,90.74l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,90.74c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,90c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M290.53,105.05c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM290.53,104.02c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,106.69l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M297.98,105.05c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.32-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM297.98,104.02c.11,0,.22-.03.31-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08s-.21.03-.31.08c-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,102.69c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,101.95c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,105.05l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,105.05c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,104.31c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-300"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,116.75v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,119.25v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,121l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.67,119.36c-.38,0-.71-.07-.99-.21-.28-.14-.51-.3-.69-.48l.7-.79c.1.11.23.2.39.28s.33.12.5.12.31-.03.45-.09c.14-.06.26-.16.37-.3.1-.14.19-.32.25-.55.06-.23.1-.51.11-.84-.07.1-.16.18-.25.26-.1.07-.2.14-.3.19-.1.05-.2.09-.31.12-.1.03-.2.04-.29.04-.25,0-.47-.04-.68-.11s-.39-.18-.54-.32c-.15-.14-.27-.33-.36-.55-.09-.22-.13-.48-.13-.78s.05-.56.15-.8c.1-.24.24-.44.41-.61.17-.17.37-.3.6-.38s.48-.13.73-.13c.28,0,.54.05.81.16s.49.28.69.5c.2.23.36.52.49.88s.18.79.18,1.29c0,.53-.06,1-.19,1.39s-.3.71-.51.96-.46.44-.74.56c-.28.12-.57.18-.87.18ZM297.88,116.17c.15,0,.3-.04.45-.13s.29-.23.4-.44c-.06-.45-.17-.76-.34-.93-.17-.17-.35-.26-.55-.26-.19,0-.36.07-.5.22-.14.15-.22.38-.22.71,0,.31.07.52.22.64.14.12.32.18.54.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-325"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,117c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,116.26c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,119.36l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,119.36c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,118.62c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-320"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M288.49,133.56v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,135.31l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M297.79,133.67c-.47,0-.86-.07-1.19-.22s-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41s.43.16.68.16c.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34s-.12-.19-.24-.26-.27-.12-.47-.16-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.11-.07.18-.15.23-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46-.12-.11-.29-.17-.52-.17-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.03.8.1.24.07.45.17.62.31.17.14.3.3.4.49.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.81.49s.32.53.32.9c0,.26-.06.5-.17.71s-.27.38-.46.52c-.19.14-.42.25-.67.32-.26.07-.53.11-.82.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,131.31c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,130.58c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,133.67l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,133.67c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,132.93c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,145.37v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.49,147.87v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,149.62l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M298.26,147.87v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM297.05,145.5h1.21v-.93c0-.19,0-.4.02-.64.01-.24.02-.45.04-.63h-.04c-.07.16-.15.31-.22.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,145.62c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,144.89c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,147.98l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,147.98c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,147.24c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,159.68v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M290.53,162.29c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM290.53,161.27c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,163.93l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.98,162.29c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32-.18-.14-.31-.3-.41-.49-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.85.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.19.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.31c.15.13.27.3.35.5s.13.41.13.64c0,.28-.08.52-.23.73-.15.21-.32.39-.52.52v.04c.28.15.51.34.7.58.19.23.29.54.29.92,0,.23-.05.44-.14.63-.1.19-.23.36-.41.5-.18.14-.39.25-.64.33-.25.08-.53.12-.83.12ZM298,161.38c.22,0,.4-.06.55-.18.14-.12.22-.3.22-.54,0-.13-.03-.23-.08-.32-.06-.09-.14-.17-.25-.25-.11-.08-.24-.15-.38-.21-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59s.38.21.62.21ZM298.34,158.85c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16-.13.11-.19.27-.19.5,0,.23.09.42.27.55.18.13.42.26.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-330"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,159.94c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,159.2c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,162.29l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,162.29c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,161.56c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,173.99v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.49,176.5v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,178.24l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.99,176.6c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM297.99,175.58c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,174.25c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,173.51c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,176.6l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,176.6c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,175.87c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-319"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,188.31v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M290.53,190.92c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM290.53,189.89c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,192.55l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M295.94,190.81v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,188.56c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,187.82c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,190.92l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,190.92c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,190.18c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-336"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,202.62v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M290.53,205.23c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM290.53,204.2c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,206.86l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M295.94,205.12v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-299"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,202.87c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,202.13c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,205.23l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,205.23c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,204.49c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M283.71,216.93v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M288.79,219.43v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M293.59,221.18l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M297.99,219.54c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM297.99,218.51c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-337"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M302.05,217.18c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,216.44c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,219.54l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,219.54c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,218.8c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,231.24v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,233.74v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,235.49l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.04,233.74c.02-.47.07-.91.13-1.31.06-.4.15-.78.27-1.14s.27-.72.45-1.07c.18-.35.41-.71.68-1.08h-2.56v-1.12h3.98v.81c-.33.4-.6.78-.8,1.13-.2.35-.36.71-.47,1.09-.11.38-.19.78-.24,1.21-.05.43-.08.92-.11,1.48h-1.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,231.49c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,230.75c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,233.85l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,233.85c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,233.11c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,245.55v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.49,248.05v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68s.65-.23,1.05-.23c.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57.09.22.13.47.13.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.04.48-.05s.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,249.8l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M295.94,248.05v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68s.65-.23,1.05-.23c.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57.09.22.13.47.13.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.04.48-.05s.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,245.8c-.21,0-.41-.04-.58-.12-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.37c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.12-.58.12ZM302.05,245.06c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,248.16l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,248.16c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.12.58-.12s.4.04.58.12c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,247.42c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,259.86v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,262.36v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,264.11l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M295.94,262.36v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73s.18-.44.18-.64c0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18s-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57s.13.47.13.75c0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.04.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,260.11c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.12.58-.12s.41.04.58.12.33.21.46.37c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,259.38c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,262.47l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,262.47c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,261.73c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-280"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,274.17v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,276.67v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.3h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,278.42l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33s.23.53.23.92c0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.99,276.78c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.43.64-.56.53-.19.84-.19.58.06.84.19.47.31.64.56.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM297.99,275.76c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31s.13-.35.17-.6.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58-.16-.24-.25-.29c-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29s-.13.34-.17.58-.06.57-.06.96.02.71.06.96.1.45.17.6.16.25.25.31.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,274.42c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.36.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58s.11.49.11.78-.04.56-.11.79-.18.43-.31.59c-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,273.69c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,276.78l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,276.78c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,276.04c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-308"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,288.48v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M290.53,291.09c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57-.31-.56-.41-.94c-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.43.64-.56.53-.18.84-.18.58.06.84.18.47.31.64.56.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94s-.39.44-.64.57-.53.19-.84.19ZM290.53,290.07c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,292.73l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33s.23.53.23.92c0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.98,291.09c-.29,0-.55-.04-.8-.11-.24-.08-.45-.18-.63-.32s-.31-.3-.41-.5c-.1-.19-.15-.41-.15-.64,0-.35.09-.63.28-.86.19-.22.42-.4.69-.55v-.04c-.22-.17-.41-.36-.55-.57-.14-.21-.22-.47-.22-.78,0-.24.04-.46.14-.65.09-.2.22-.36.38-.5.16-.14.36-.24.58-.31.22-.07.47-.11.73-.11s.5.04.71.11.4.18.55.32c.15.13.27.3.35.5.08.19.13.41.13.64,0,.28-.08.52-.23.73-.15.21-.32.39-.52.52v.04c.28.15.51.34.7.58.19.23.29.54.29.92,0,.23-.05.44-.14.63-.1.19-.23.36-.41.5s-.39.25-.64.33c-.25.08-.53.12-.83.12ZM298,290.17c.22,0,.4-.06.55-.17.14-.12.22-.3.22-.54,0-.13-.03-.23-.08-.32-.06-.09-.14-.17-.25-.25s-.24-.15-.38-.21c-.15-.07-.31-.14-.49-.22-.13.12-.23.26-.31.41-.08.16-.13.32-.13.5,0,.25.09.45.26.59.17.14.38.21.62.21ZM298.34,287.65c.23-.27.35-.55.35-.84,0-.22-.06-.4-.18-.54-.12-.13-.29-.2-.51-.2-.17,0-.32.05-.45.16s-.19.27-.19.5c0,.23.09.42.27.55.18.13.42.25.71.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,288.73c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.37c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,288c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,291.09l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,291.09c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,290.35c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,302.79v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M290.34,305.4c-.47,0-.86-.07-1.19-.22-.32-.15-.59-.34-.8-.59l.61-.84c.17.17.36.31.57.41.21.11.43.16.68.16.28,0,.51-.06.67-.18.17-.12.25-.28.25-.5,0-.13-.02-.24-.07-.34-.04-.1-.12-.19-.24-.26-.11-.07-.27-.12-.47-.16-.2-.04-.45-.06-.76-.06v-.94c.26,0,.47-.02.64-.05.17-.04.31-.09.41-.16.1-.07.18-.15.22-.24.04-.09.07-.2.07-.31,0-.2-.06-.35-.18-.46s-.29-.17-.52-.17c-.2,0-.39.04-.55.14-.17.09-.34.21-.52.37l-.67-.81c.26-.23.54-.41.83-.54s.61-.19.97-.19c.29,0,.56.04.81.1.24.07.45.17.62.31s.3.3.4.49c.1.19.14.41.14.67,0,.3-.08.55-.25.76s-.4.38-.71.51v.04c.33.1.6.26.82.49.21.23.32.53.32.9,0,.26-.06.5-.17.71-.11.21-.27.38-.46.52-.19.14-.42.25-.68.32-.26.07-.53.11-.82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,307.04l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M297.99,305.4c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.31-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.44.64-.56c.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM297.99,304.38c.11,0,.22-.03.32-.08.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08s-.18.15-.25.29c-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.08.31.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,303.04c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,302.31c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,305.4l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,305.4c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,304.67c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M290.53,319.71c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57-.31-.56-.41-.94c-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.43.64-.56.53-.18.84-.18.58.06.84.18.47.31.64.56.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94s-.39.44-.64.57-.53.19-.84.19ZM290.53,318.69c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,321.35l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33s.23.53.23.92c0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M295.94,319.61v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84s.39-.5.51-.73c.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68s.64-.23,1.05-.23c.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.04.48-.05s.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,317.36c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.37c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,316.62c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,319.71l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,319.71c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,318.98c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M288.79,333.92v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,335.66l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M295.94,333.92v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73s.18-.44.18-.64c0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.64-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37s.3.35.39.57c.09.22.14.47.14.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,331.67c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,330.93c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,334.03l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,334.03c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,333.29c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M288.79,348.23v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,349.97l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33s.23.53.23.92c0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M297.98,348.34c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.32-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.43.64-.56s.53-.18.84-.18.58.06.84.18.47.31.64.56.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94s-.39.44-.64.57-.53.19-.84.19ZM297.98,347.31c.11,0,.22-.03.31-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08s-.21.03-.31.08c-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,345.98c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.37c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,345.24c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,348.34l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,348.34c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,347.6c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,360.04v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M288.79,362.54v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,364.29l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M298.26,362.54v-1.37h-2.48v-.91l2.09-3.44h1.62v3.34h.66v1.01h-.66v1.37h-1.23ZM297.05,360.16h1.21v-.93c0-.19,0-.4.02-.64s.02-.45.04-.63h-.04c-.07.16-.15.32-.22.48s-.16.32-.24.49l-.76,1.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-329"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,360.29c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,359.55c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,362.65l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,362.65c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,361.91c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M283.71,374.35v-.94h4.14v.94h-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M290.53,376.96c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57-.31-.56-.41-.94c-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.43.64-.56.53-.18.84-.18.58.06.84.18.47.31.64.56.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94s-.39.44-.64.57-.53.19-.84.19ZM290.53,375.93c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M293.59,378.6l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33s.23.53.23.92c0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M295.94,376.85v-.76c.37-.34.7-.66,1-.96s.56-.58.78-.84c.22-.26.39-.5.51-.73.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68s.65-.23,1.05-.23c.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57.09.22.13.47.13.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.04.48-.05s.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M302.05,374.6c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.37c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,373.86c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,376.96l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,376.96c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,376.22c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M288.79,391.16v-1.07h1.24v-3.3h-1.07v-.82c.31-.06.58-.13.79-.22.22-.08.43-.19.63-.31h.97v4.64h1.07v1.07h-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,392.91l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M297.98,391.27c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57c-.18-.25-.32-.56-.41-.94-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92.18-.25.39-.44.64-.56.25-.12.53-.18.84-.18s.58.06.84.18c.25.12.47.31.64.56s.31.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94-.18.25-.39.44-.64.57s-.53.19-.84.19ZM297.98,390.24c.11,0,.22-.03.31-.08.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.31-.08s-.21.03-.31.08c-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.08.31.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,388.91c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,388.17c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,391.27l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,391.27c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,390.53c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M290.53,405.58c-.31,0-.58-.06-.84-.19s-.47-.32-.64-.57-.31-.56-.41-.94c-.1-.37-.15-.8-.15-1.29s.05-.91.15-1.28c.1-.37.24-.67.41-.92s.39-.43.64-.56.53-.18.84-.18.58.06.84.18.47.31.64.56.32.56.41.92c.1.37.15.79.15,1.28s-.05.92-.15,1.29c-.1.37-.24.68-.41.94s-.39.44-.64.57-.53.19-.84.19ZM290.53,404.55c.11,0,.22-.03.32-.09.1-.06.18-.16.25-.31.07-.15.13-.35.17-.6s.06-.57.06-.96-.02-.71-.06-.96-.09-.44-.17-.58c-.07-.14-.16-.24-.25-.29-.1-.05-.2-.08-.32-.08-.11,0-.21.03-.31.08-.1.05-.18.15-.25.29-.07.14-.13.34-.17.58s-.06.57-.06.96.02.71.06.96.1.45.17.6c.07.15.16.25.25.31.1.06.2.09.31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,407.22l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55s.08-.41.24-.55c.16-.14.36-.21.59-.21.3,0,.53.11.68.33s.23.53.23.92c0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M295.94,405.47v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84s.39-.5.51-.73c.12-.23.18-.44.18-.64,0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18-.16.12-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68s.64-.23,1.05-.23c.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57.09.22.14.47.14.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75-.17.25-.37.5-.58.75-.22.25-.45.49-.68.73.14-.02.3-.04.48-.05s.33-.02.47-.02h1.15v1.12h-4.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,403.22c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58.13-.16.28-.28.46-.37.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.37c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,402.48c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,405.58l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,405.58c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37-.13-.16-.23-.36-.3-.59-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.36s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37-.18.08-.38.13-.58.13ZM306.38,404.84c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88.23.25.38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M288.49,419.78v-.76c.37-.34.7-.66,1-.96.3-.3.56-.58.78-.84.22-.26.39-.5.51-.73s.18-.44.18-.64c0-.28-.07-.5-.22-.64-.14-.15-.34-.22-.59-.22-.21,0-.4.06-.56.18s-.32.25-.46.41l-.72-.71c.28-.3.57-.53.86-.68.29-.15.65-.23,1.05-.23.28,0,.54.04.77.13.23.09.43.21.6.37.17.16.3.35.39.57.09.22.13.47.13.75,0,.24-.05.48-.15.73-.1.25-.24.5-.41.75s-.37.5-.58.75-.45.49-.68.73c.14-.02.3-.03.48-.05.18-.02.33-.02.47-.02h1.15v1.12h-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M293.59,421.53l-.27-.7c.34-.12.59-.28.77-.47.17-.19.26-.4.25-.63h-.07c-.21,0-.4-.06-.56-.19-.16-.13-.24-.31-.24-.55,0-.23.08-.41.24-.55.16-.14.36-.21.59-.21.3,0,.53.11.68.33.16.22.23.53.23.92,0,.5-.14.93-.41,1.28-.28.36-.68.61-1.21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M297.83,419.89c-.47,0-.86-.08-1.19-.23-.32-.15-.6-.34-.83-.57l.59-.84c.17.16.36.29.56.4.2.11.42.17.67.17.29,0,.53-.08.7-.22.17-.15.26-.37.26-.67s-.08-.51-.25-.66-.38-.22-.65-.22c-.08,0-.16,0-.22.01-.07,0-.13.03-.19.05-.06.02-.13.05-.2.09-.07.04-.15.08-.23.13l-.59-.38.16-2.89h3.24v1.12h-2.1l-.1,1.07c.11-.05.21-.08.31-.1.1-.02.21-.03.33-.03.25,0,.48.04.7.11s.41.18.58.32c.17.14.3.33.4.55s.14.49.14.79-.06.6-.17.85c-.11.25-.27.46-.46.63-.19.17-.42.3-.67.39-.25.09-.52.13-.8.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M302.05,417.53c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.36c.18-.08.38-.13.58-.13s.41.04.58.13.33.21.46.36c.13.16.23.35.31.58.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59-.13.16-.28.29-.46.37s-.38.13-.58.13ZM302.05,416.8c.15,0,.28-.08.38-.25.1-.17.16-.46.16-.88s-.05-.71-.16-.87c-.11-.16-.23-.24-.38-.24s-.28.08-.38.24c-.1.16-.16.45-.16.87s.05.71.16.88c.11.17.23.25.38.25ZM302.25,419.89l3.17-6.08h.76l-3.17,6.08h-.76ZM306.38,419.89c-.21,0-.41-.04-.58-.13-.18-.08-.33-.21-.46-.37s-.23-.36-.3-.59c-.07-.23-.11-.49-.11-.79s.04-.55.11-.78c.07-.23.17-.42.3-.58s.28-.28.46-.37c.18-.08.38-.13.58-.13s.4.04.58.13c.18.08.33.21.46.37s.23.35.31.58c.08.23.11.49.11.78s-.04.56-.11.79c-.08.23-.18.43-.31.59s-.28.29-.46.37c-.18.08-.38.13-.58.13ZM306.38,419.15c.15,0,.28-.08.38-.25.11-.17.16-.46.16-.88s-.05-.71-.16-.87c-.1-.16-.23-.24-.38-.24s-.28.08-.38.24-.16.45-.16.87.05.71.16.88.23.25.38.25Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M74.73,1.63c1.73,0,2.62.97,2.62.97l-.62.96s-.81-.75-1.94-.75c-1.5,0-2.38,1.12-2.38,2.44s.91,2.54,2.39,2.54c1.23,0,2.06-.9,2.06-.9l.68.93s-.98,1.15-2.79,1.15c-2.17,0-3.67-1.61-3.67-3.7s1.56-3.64,3.65-3.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M78.53,1.75h1.27v2.46c0,.25-.02.43-.02.43h.02c.25-.49.87-1.01,1.76-1.01,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.19.44-1.38,1.06c-.06.2-.08.42-.08.66v2.34h-1.27V1.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M87.25,5.64h.17v-.07c0-.67-.42-.9-.98-.9-.73,0-1.4.49-1.4.49l-.48-.91s.79-.63,2-.63c1.34,0,2.12.74,2.12,2.03v3.19h-1.17v-.42c0-.2.02-.36.02-.36h-.02s-.39.9-1.55.9c-.91,0-1.73-.57-1.73-1.59,0-1.62,2.19-1.73,3.02-1.73ZM86.28,7.97c.67,0,1.15-.72,1.15-1.34v-.12h-.22c-.65,0-1.7.09-1.7.8,0,.34.25.66.77.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M90,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M98.06,9.86c.78,0,1.44-.33,1.44-1.24v-.3c0-.12.02-.27.02-.27h-.02c-.3.45-.74.69-1.42.69-1.46,0-2.29-1.18-2.29-2.58s.79-2.54,2.26-2.54c1.11,0,1.51.65,1.51.65h.03s0-.06,0-.14v-.39h1.19v4.79c0,1.75-1.36,2.41-2.69,2.41-.64,0-1.32-.18-1.81-.44l.38-.97s.64.33,1.41.33ZM99.53,6.17c0-1.16-.57-1.47-1.26-1.47-.77,0-1.2.56-1.2,1.42s.46,1.55,1.28,1.55c.61,0,1.18-.35,1.18-1.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M104.4,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM105.38,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M110.14,1.75h1.26v1.13h-1.26v-1.13ZM110.14,3.75h1.27v5.1h-1.27V3.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M112.81,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M123.6,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM124.58,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M126.91,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M135.27,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM136.25,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M138.58,3.75h1.22v.88c0,.19-.02.36-.02.36h.02c.23-.73.84-1.31,1.62-1.31.12,0,.23.02.23.02v1.25s-.13-.02-.3-.02c-.54,0-1.15.31-1.39,1.07-.08.25-.11.53-.11.83v2.02h-1.27V3.75Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M144.44,9.86c.78,0,1.44-.33,1.44-1.24v-.3c0-.12.02-.27.02-.27h-.02c-.3.45-.74.69-1.42.69-1.46,0-2.29-1.18-2.29-2.58s.79-2.54,2.26-2.54c1.11,0,1.51.65,1.51.65h.03s0-.06,0-.14v-.39h1.19v4.79c0,1.75-1.36,2.41-2.69,2.41-.64,0-1.32-.18-1.81-.44l.38-.97s.64.33,1.41.33ZM145.91,6.17c0-1.16-.57-1.47-1.26-1.47-.77,0-1.2.56-1.2,1.42s.46,1.55,1.28,1.55c.61,0,1.18-.35,1.18-1.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M148.28,9.66s.28.21.57.21c.35,0,.69-.21.88-.66l.19-.45-2.15-5.02h1.43l1.07,2.94c.1.27.19.69.19.69h.02s.08-.4.17-.67l1-2.96h1.39l-2.28,5.87c-.36.93-1.07,1.33-1.84,1.33-.61,0-1.06-.33-1.06-.33l.42-.95Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M156.19,3.75h1.16v.37c0,.19-.02.35-.02.35h.02s.44-.84,1.64-.84c1.38,0,2.26,1.09,2.26,2.67s-.99,2.67-2.33,2.67c-1.01,0-1.46-.7-1.46-.7h-.02s.02.18.02.44v2.14h-1.27V3.75ZM158.69,7.89c.7,0,1.28-.57,1.28-1.58s-.52-1.6-1.27-1.6c-.66,0-1.28.48-1.28,1.61,0,.79.43,1.57,1.27,1.57Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M162.3,3.75h1.22v.88c0,.19-.02.36-.02.36h.02c.23-.73.84-1.31,1.62-1.31.12,0,.23.02.23.02v1.25s-.13-.02-.3-.02c-.54,0-1.15.31-1.39,1.07-.08.25-.11.53-.11.83v2.02h-1.27V3.75Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M166.23,1.75h1.26v1.13h-1.26v-1.13ZM166.23,3.75h1.27v5.1h-1.27V3.75Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M171.3,3.63c1.33,0,1.96.76,1.96.76l-.56.87s-.53-.55-1.33-.55c-.94,0-1.55.71-1.55,1.58s.62,1.6,1.59,1.6c.86,0,1.5-.65,1.5-.65l.49.9s-.73.83-2.1.83c-1.69,0-2.77-1.19-2.77-2.67s1.08-2.67,2.77-2.67Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M176.58,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM177.56,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M180.04,7.32s.56.56,1.39.56c.36,0,.67-.16.67-.46,0-.76-2.48-.66-2.48-2.3,0-.95.85-1.5,1.95-1.5s1.71.58,1.71.58l-.47.94s-.47-.44-1.25-.44c-.33,0-.65.14-.65.46,0,.72,2.48.63,2.48,2.27,0,.85-.74,1.53-1.95,1.53-1.27,0-1.98-.75-1.98-.75l.58-.89Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M71.21,19.44c0-2.22,3.24-2.51,3.24-4.22,0-.69-.52-1.22-1.31-1.22-.93,0-1.41.86-1.41.86l-.47-.31s.58-1.14,1.92-1.14c1.21,0,1.93.78,1.93,1.77,0,2.12-3.2,2.42-3.21,4.11h3.3v.56h-3.95c-.03-.14-.04-.28-.04-.41Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M76.39,16.67c0-1.82.54-3.27,2.19-3.27s2.18,1.45,2.18,3.27-.53,3.28-2.18,3.28-2.19-1.44-2.19-3.28ZM80.1,16.67c0-1.5-.33-2.68-1.53-2.68s-1.54,1.18-1.54,2.68.33,2.69,1.54,2.69,1.53-1.18,1.53-2.69Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M81.89,19.28h1.42v-4.65c0-.18,0-.35,0-.35h-.02s-.06.14-.32.38l-.67.68-.4-.4,1.43-1.42h.58v5.77h1.4v.56h-3.43v-.56Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M86.39,19.69l.23-.55s.4.23.92.23c1.33,0,2-1.31,2.12-2.54h-.02c-.32.45-.95.74-1.61.74-1.15,0-1.96-.85-1.96-2.04,0-1.31.87-2.12,1.98-2.12,1.38,0,2.29,1.26,2.29,2.97,0,1.58-.82,3.57-2.78,3.57-.69,0-1.16-.26-1.16-.26ZM89.66,15.93c0-.85-.66-1.94-1.6-1.94-.85,0-1.36.65-1.36,1.52s.57,1.49,1.43,1.49,1.53-.57,1.53-1.08Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M91.86,17.01h2.56v.56h-2.56v-.56Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M95.89,19.44c0-2.22,3.24-2.51,3.24-4.22,0-.69-.52-1.22-1.31-1.22-.93,0-1.41.86-1.41.86l-.47-.31s.58-1.14,1.92-1.14c1.21,0,1.93.78,1.93,1.77,0,2.12-3.2,2.42-3.21,4.11h3.3v.56h-3.95c-.03-.14-.04-.28-.04-.41Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M101.06,16.67c0-1.82.54-3.27,2.19-3.27s2.18,1.45,2.18,3.27-.53,3.28-2.18,3.28-2.19-1.44-2.19-3.28ZM104.78,16.67c0-1.5-.33-2.68-1.53-2.68s-1.54,1.18-1.54,2.68.33,2.69,1.54,2.69,1.53-1.18,1.53-2.69Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M106.6,19.44c0-2.22,3.24-2.51,3.24-4.22,0-.69-.52-1.22-1.31-1.22-.93,0-1.41.86-1.41.86l-.47-.31s.58-1.14,1.92-1.14c1.21,0,1.93.78,1.93,1.77,0,2.12-3.2,2.42-3.21,4.11h3.3v.56h-3.95c-.03-.14-.04-.28-.04-.41Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M111.93,18.61s.65.75,1.62.75c.76,0,1.45-.56,1.45-1.37,0-.89-.77-1.35-1.59-1.35h-.43l-.15-.37,1.58-1.85c.17-.2.33-.35.33-.35v-.02s-.18.03-.51.03h-2.38v-.56h3.7v.41l-1.89,2.18c.8.05,1.98.5,1.98,1.86,0,1.08-.88,1.98-2.08,1.98s-2.01-.86-2.01-.86l.38-.48Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M287.46,1.63c1.73,0,2.62.97,2.62.97l-.62.96s-.81-.75-1.94-.75c-1.5,0-2.38,1.12-2.38,2.44s.91,2.54,2.39,2.54c1.23,0,2.06-.9,2.06-.9l.68.93s-.98,1.15-2.79,1.15c-2.17,0-3.67-1.61-3.67-3.7s1.56-3.64,3.65-3.64Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M291.27,1.75h1.27v2.46c0,.25-.02.43-.02.43h.02c.25-.49.87-1.01,1.76-1.01,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.19.44-1.38,1.06c-.06.2-.08.42-.08.66v2.34h-1.27V1.75Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M299.98,5.64h.17v-.07c0-.67-.42-.9-.98-.9-.73,0-1.4.49-1.4.49l-.48-.91s.79-.63,2-.63c1.34,0,2.12.74,2.12,2.03v3.19h-1.17v-.42c0-.2.02-.36.02-.36h-.02s-.39.9-1.55.9c-.91,0-1.73-.57-1.73-1.59,0-1.62,2.19-1.73,3.02-1.73ZM299.01,7.97c.67,0,1.15-.72,1.15-1.34v-.12h-.22c-.65,0-1.7.09-1.7.8,0,.34.25.66.77.66Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M302.73,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M310.79,9.86c.78,0,1.44-.33,1.44-1.24v-.3c0-.12.02-.27.02-.27h-.02c-.3.45-.74.69-1.42.69-1.46,0-2.29-1.18-2.29-2.58s.79-2.54,2.26-2.54c1.11,0,1.51.65,1.51.65h.03s0-.06,0-.14v-.39h1.19v4.79c0,1.75-1.36,2.41-2.69,2.41-.64,0-1.32-.18-1.81-.44l.38-.97s.64.33,1.41.33ZM312.26,6.17c0-1.16-.57-1.47-1.26-1.47-.77,0-1.2.56-1.2,1.42s.46,1.55,1.28,1.55c.61,0,1.18-.35,1.18-1.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M317.13,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM318.11,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M322.88,1.75h1.26v1.13h-1.26v-1.13ZM322.88,3.75h1.27v5.1h-1.27V3.75Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M325.54,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M336.33,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM337.31,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M339.64,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M348,3.63c1.47,0,2.26,1.07,2.26,2.42,0,.15-.03.49-.03.49h-3.52c.08.89.77,1.35,1.53,1.35.82,0,1.47-.56,1.47-.56l.49.91s-.78.73-2.05.73c-1.69,0-2.74-1.22-2.74-2.67,0-1.57,1.07-2.67,2.59-2.67ZM348.98,5.66c-.02-.69-.45-1.06-1.01-1.06-.65,0-1.1.4-1.22,1.06h2.23Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M351.31,3.75h1.22v.88c0,.19-.02.36-.02.36h.02c.23-.73.84-1.31,1.62-1.31.12,0,.23.02.23.02v1.25s-.13-.02-.3-.02c-.54,0-1.15.31-1.39,1.07-.08.25-.11.53-.11.83v2.02h-1.27V3.75Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M357.17,9.86c.78,0,1.44-.33,1.44-1.24v-.3c0-.12.02-.27.02-.27h-.02c-.3.45-.74.69-1.42.69-1.46,0-2.29-1.18-2.29-2.58s.79-2.54,2.26-2.54c1.11,0,1.51.65,1.51.65h.03s0-.06,0-.14v-.39h1.19v4.79c0,1.75-1.36,2.41-2.69,2.41-.64,0-1.32-.18-1.81-.44l.38-.97s.64.33,1.41.33ZM358.64,6.17c0-1.16-.57-1.47-1.26-1.47-.77,0-1.2.56-1.2,1.42s.46,1.55,1.28,1.55c.61,0,1.18-.35,1.18-1.5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M361.01,9.66s.28.21.57.21c.35,0,.69-.21.88-.66l.19-.45-2.15-5.02h1.43l1.07,2.94c.1.27.19.69.19.69h.02s.08-.4.17-.67l1-2.96h1.39l-2.28,5.87c-.36.93-1.07,1.33-1.84,1.33-.61,0-1.06-.33-1.06-.33l.42-.95Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M371.32,3.63c1.33,0,1.96.76,1.96.76l-.56.87s-.53-.55-1.33-.55c-.94,0-1.55.71-1.55,1.58s.62,1.6,1.59,1.6c.86,0,1.5-.65,1.5-.65l.49.9s-.73.83-2.1.83c-1.69,0-2.77-1.19-2.77-2.67s1.08-2.67,2.77-2.67Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M376.79,3.63c1.56,0,2.81,1.11,2.81,2.67s-1.25,2.67-2.8,2.67-2.81-1.1-2.81-2.67,1.25-2.67,2.8-2.67ZM376.8,7.88c.82,0,1.51-.64,1.51-1.59s-.69-1.59-1.51-1.59-1.52.65-1.52,1.59.69,1.59,1.52,1.59Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M380.62,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M386.9,7.32s.56.56,1.39.56c.36,0,.67-.16.67-.46,0-.76-2.48-.66-2.48-2.3,0-.95.85-1.5,1.95-1.5s1.71.58,1.71.58l-.47.94s-.47-.44-1.25-.44c-.33,0-.65.14-.65.46,0,.72,2.48.63,2.48,2.27,0,.85-.74,1.53-1.95,1.53-1.27,0-1.98-.75-1.98-.75l.58-.89Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M391.2,3.75h1.27v3.02c0,.62.16,1.04.79,1.04.92,0,1.43-.81,1.43-1.72v-2.34h1.27v5.1h-1.22v-.58c0-.2.02-.36.02-.36h-.02c-.25.53-.9,1.06-1.77,1.06-1.09,0-1.77-.55-1.77-1.94v-3.28Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M397.36,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.25-.5.86-1.06,1.66-1.06s1.28.36,1.49,1.05h.02c.28-.55.94-1.05,1.74-1.05,1.06,0,1.67.6,1.67,1.94v3.28h-1.27v-3.04c0-.58-.11-1.02-.7-1.02-.65,0-1.08.52-1.23,1.16-.05.2-.06.42-.06.66v2.24h-1.27v-3.04c0-.55-.09-1.02-.69-1.02-.66,0-1.09.52-1.25,1.17-.05.19-.06.42-.06.65v2.24h-1.27V3.75Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M406.49,3.75h1.16v.37c0,.19-.02.35-.02.35h.02s.44-.84,1.64-.84c1.38,0,2.26,1.09,2.26,2.67s-.99,2.67-2.33,2.67c-1.01,0-1.46-.7-1.46-.7h-.02s.02.18.02.44v2.14h-1.27V3.75ZM408.99,7.89c.7,0,1.28-.57,1.28-1.58s-.52-1.6-1.27-1.6c-.66,0-1.28.48-1.28,1.61,0,.79.43,1.57,1.27,1.57Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M412.82,4.83h-.66v-1.01h.69v-1.47h1.24v1.47h1.16v1.01h-1.16v1.98c0,.84.66.96,1.01.96.14,0,.23-.02.23-.02v1.11s-.15.03-.39.03c-.71,0-2.12-.21-2.12-1.92v-2.14Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M416.37,1.75h1.26v1.13h-1.26v-1.13ZM416.37,3.75h1.27v5.1h-1.27V3.75Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M421.46,3.63c1.56,0,2.81,1.11,2.81,2.67s-1.25,2.67-2.8,2.67-2.81-1.1-2.81-2.67,1.25-2.67,2.8-2.67ZM421.47,7.88c.82,0,1.51-.64,1.51-1.59s-.69-1.59-1.51-1.59-1.52.65-1.52,1.59.69,1.59,1.52,1.59Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M425.29,3.75h1.22v.59c0,.19-.02.35-.02.35h.02c.22-.43.78-1.06,1.81-1.06,1.13,0,1.77.59,1.77,1.94v3.28h-1.26v-3.02c0-.62-.16-1.04-.81-1.04s-1.18.43-1.37,1.04c-.07.21-.09.44-.09.68v2.34h-1.27V3.75Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M283.95,19.44c0-2.22,3.24-2.51,3.24-4.22,0-.69-.52-1.22-1.31-1.22-.93,0-1.41.86-1.41.86l-.47-.31s.58-1.14,1.92-1.14c1.21,0,1.93.78,1.93,1.77,0,2.12-3.2,2.42-3.21,4.11h3.3v.56h-3.95c-.03-.14-.04-.28-.04-.41Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M289.12,16.67c0-1.82.54-3.27,2.19-3.27s2.18,1.45,2.18,3.27-.53,3.28-2.18,3.28-2.19-1.44-2.19-3.28ZM292.84,16.67c0-1.5-.33-2.68-1.53-2.68s-1.54,1.18-1.54,2.68.33,2.69,1.54,2.69,1.53-1.18,1.53-2.69Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M294.62,19.28h1.42v-4.65c0-.18,0-.35,0-.35h-.02s-.06.14-.31.38l-.68.68-.4-.4,1.43-1.42h.58v5.77h1.4v.56h-3.43v-.56Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M299.13,19.69l.23-.55s.39.23.92.23c1.33,0,2-1.31,2.12-2.54h-.02c-.32.45-.96.74-1.61.74-1.15,0-1.96-.85-1.96-2.04,0-1.31.87-2.12,1.98-2.12,1.38,0,2.29,1.26,2.29,2.97,0,1.58-.82,3.57-2.78,3.57-.69,0-1.16-.26-1.16-.26ZM302.4,15.93c0-.85-.66-1.94-1.6-1.94-.85,0-1.36.65-1.36,1.52s.57,1.49,1.43,1.49,1.53-.57,1.53-1.08Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M304.59,17.01h2.56v.56h-2.56v-.56Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M308.62,19.44c0-2.22,3.24-2.51,3.24-4.22,0-.69-.52-1.22-1.31-1.22-.93,0-1.41.86-1.41.86l-.47-.31s.58-1.14,1.92-1.14c1.21,0,1.93.78,1.93,1.77,0,2.12-3.2,2.42-3.21,4.11h3.3v.56h-3.95c-.03-.14-.04-.28-.04-.41Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M313.8,16.67c0-1.82.54-3.27,2.19-3.27s2.18,1.45,2.18,3.27-.53,3.28-2.18,3.28-2.19-1.44-2.19-3.28ZM317.52,16.67c0-1.5-.33-2.68-1.53-2.68s-1.54,1.18-1.54,2.68.33,2.69,1.54,2.69,1.53-1.18,1.53-2.69Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M319.33,19.44c0-2.22,3.24-2.51,3.24-4.22,0-.69-.52-1.22-1.31-1.22-.93,0-1.41.86-1.41.86l-.47-.31s.58-1.14,1.92-1.14c1.21,0,1.93.78,1.93,1.77,0,2.12-3.2,2.42-3.21,4.11h3.3v.56h-3.95c-.03-.14-.04-.28-.04-.41Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M324.66,18.61s.65.75,1.62.75c.76,0,1.45-.56,1.45-1.37,0-.89-.77-1.35-1.59-1.35h-.43l-.15-.37,1.58-1.85c.17-.2.33-.35.33-.35v-.02s-.18.03-.51.03h-2.38v-.56h3.7v.41l-1.89,2.18c.8.05,1.98.5,1.98,1.86,0,1.08-.88,1.98-2.08,1.98s-2.01-.86-2.01-.86l.38-.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyConsumptionAndPricesDesktop);
export default __webpack_public_path__ + "static/media/energy-consumption-and-prices-desktop.4152eeb94fbe13094d64fdcb34e5a15b.svg";
export { ForwardRef as ReactComponent };